if (window._0xlock !== true) {
  try {
    document.documentElement.innerHTML = "";
  } catch (e) {}
  throw new Error("Integrity check failed");
}
;
try {
  document.querySelector(":focus-visible");
} catch (_0x310fa6) {
  focusVisiblePolyfill();
}
const defaultDirection = document.currentScript && document.currentScript.dataset.isRtl === "true" ? "rtl" : "ltr";
const isRtl = defaultDirection === "rtl";
function focusVisiblePolyfill() {
  let _0xba19f8 = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let _0x1dbe03 = null;
  let _0x30058e = null;
  window.addEventListener("keydown", _0x18347a => {
    if (_0xba19f8.includes(_0x18347a.code.toUpperCase())) {
      _0x30058e = false;
    }
  });
  window.addEventListener("mousedown", _0x54882f => {
    _0x30058e = true;
  });
  window.addEventListener("focus", () => {
    if (_0x1dbe03) {
      _0x1dbe03.classList.remove("focused");
    }
    if (!_0x30058e) {
      (_0x1dbe03 = document.activeElement).classList.add("focused");
    }
  }, true);
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let _0x3f9e90 = (_0x1112cb, _0x2e45a9) => {
      if (_0x1112cb[0].isIntersecting) {
        _0x2e45a9.unobserve(this);
        if (this.dataset.loaded !== "true") {
          this.loadProducts();
        }
      }
    };
    new IntersectionObserver(_0x3f9e90.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
  loadProducts() {
    if (this.dataset.loaded !== "true") {
      fetch(this.dataset.url).then(_0x57fea7 => _0x57fea7.text()).then(_0x5ce494 => {
        let _0x1ed83a = document.createElement("div");
        _0x1ed83a.innerHTML = _0x5ce494;
        let _0x125511 = _0x1ed83a.querySelector("product-recommendations");
        let _0x20af17 = "";
        if (_0x125511 && _0x125511.innerHTML.trim().length) {
          _0x20af17 = _0x125511.innerHTML;
          if (this.dataset.isUpsellBlock === "true" && !_0x20af17.includes("-upsell") && !_0x20af17.includes("data-selected")) {
            _0x20af17 = "";
          }
        }
        if (_0x20af17.trim().length) {
          this.innerHTML = _0x20af17;
          if (this.dataset.isUpsellBlock === "true") {
            if (_0x125511.classList.contains("upsells-container--stacked-columns")) {
              this.classList.add("upsells-container--stacked-columns");
            }
            if (_0x125511.classList.contains("side-margins-negative")) {
              this.classList.add("side-margins-negative");
            }
            this.dataset.count = _0x125511.dataset.count;
            getComputedStyle(_0x125511);
            getComputedStyle(_0x125511).getPropertyValue("--item-count");
            this.style.setProperty("--item-count", _0x125511.dataset.count);
          }
        }
        if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
          this.remove();
        }
        if (_0x1ed83a.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
        this.dataset.loaded = "true";
      }).catch(_0x547f12 => {
        console.error(_0x547f12);
      });
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach(_0xa29e09 => _0xa29e09.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button:not(.menu-drawer__close-menu-btn)").forEach(_0x12a28e => _0x12a28e.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(_0x5d9399) {
    if (_0x5d9399.code.toUpperCase() !== "ESCAPE") {
      return;
    }
    let _0x4bb54e = _0x5d9399.target.closest("details[open]");
    if (_0x4bb54e) {
      if (_0x4bb54e === this.mainDetailsToggle) {
        this.closeMenuDrawer(_0x5d9399, this.mainDetailsToggle.querySelector("summary"));
      } else {
        this.closeSubmenu(_0x4bb54e);
      }
    }
  }
  onSummaryClick(_0x1b375d) {
    let _0x4c9227 = _0x1b375d.currentTarget;
    let _0x28cf64 = _0x4c9227.parentNode;
    let _0x459d27 = _0x28cf64.closest(".has-submenu");
    let _0x14cc2b = _0x28cf64.hasAttribute("open");
    let _0x2d64d4 = window.matchMedia("(prefers-reduced-motion: reduce)");
    function _0x1e1ff7() {
      trapFocus(_0x4c9227.nextElementSibling, _0x28cf64.querySelector("button"));
      _0x4c9227.nextElementSibling.removeEventListener("transitionend", _0x1e1ff7);
    }
    if (_0x28cf64 === this.mainDetailsToggle) {
      if (_0x14cc2b) {
        _0x1b375d.preventDefault();
      }
      if (_0x14cc2b) {
        this.closeMenuDrawer(_0x1b375d, _0x4c9227);
      } else {
        this.openMenuDrawer(_0x4c9227);
      }
      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", window.innerHeight + "px");
      }
    } else {
      setTimeout(() => {
        _0x28cf64.classList.add("menu-opening");
        _0x4c9227.setAttribute("aria-expanded", true);
        if (_0x459d27) {
          _0x459d27.classList.add("submenu-open");
        }
        if (!_0x2d64d4 || _0x2d64d4.matches) {
          _0x1e1ff7();
        } else {
          _0x4c9227.nextElementSibling.addEventListener("transitionend", _0x1e1ff7);
        }
      }, 100);
    }
  }
  openMenuDrawer(_0x66aa89) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    _0x66aa89.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, _0x66aa89);
    document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
  }
  closeMenuDrawer(_0x2ea233, _0x5582ca = false) {
    if (_0x2ea233 !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach(_0x4a818e => {
        _0x4a818e.removeAttribute("open");
        _0x4a818e.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(_0x147700 => {
        _0x147700.classList.remove("submenu-open");
      });
      document.body.classList.remove("overflow-hidden-" + this.dataset.breakpoint);
      removeTrapFocus(_0x5582ca);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }
  onFocusOut(_0x283e94) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }
  onCloseButtonClick(_0x33f34d) {
    let _0x547797 = _0x33f34d.currentTarget.closest("details");
    this.closeSubmenu(_0x547797);
  }
  closeSubmenu(_0x1558e6) {
    let _0x5d3560 = _0x1558e6.closest(".submenu-open");
    if (_0x5d3560) {
      _0x5d3560.classList.remove("submenu-open");
    }
    _0x1558e6.classList.remove("menu-opening");
    _0x1558e6.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(_0x1558e6.querySelector("summary"));
    this.closeAnimation(_0x1558e6);
  }
  closeAnimation(_0x29c4d7) {
    let _0x3e775c;
    let _0x39077d = _0x26d930 => {
      if (_0x3e775c === undefined) {
        _0x3e775c = _0x26d930;
      }
      let _0xaf72be = _0x26d930 - _0x3e775c;
      if (_0xaf72be < 400) {
        window.requestAnimationFrame(_0x39077d);
      } else {
        _0x29c4d7.removeAttribute("open");
        if (_0x29c4d7.closest("details[open]")) {
          trapFocus(_0x29c4d7.closest("details[open]"), _0x29c4d7.querySelector("summary"));
        }
      }
    };
    window.requestAnimationFrame(_0x39077d);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.querySelectorAll(".menu-drawer__close-menu-btn").forEach(_0x5a7b24 => _0x5a7b24.addEventListener("click", this.closeButtonClick.bind(this)));
  }
  openMenuDrawer(_0x1d5f9c) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset) + "px");
    this.header.classList.add("menu-open");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    _0x1d5f9c.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, _0x1d5f9c);
    document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
  }
  closeMenuDrawer(_0x2d66cb, _0x3197a2) {
    super.closeMenuDrawer(_0x2d66cb, _0x3197a2);
    this.header.classList.remove("menu-open");
  }
  closeButtonClick(_0x33c6af) {
    this.closeMenuDrawer(_0x33c6af, this.mainDetailsToggle.querySelector("summary"));
    this.querySelector(".header__icon--menu[aria-expanded=true]").setAttribute("aria-expanded", "false");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ProductsMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details[id^=\"ProductsMegaMenu-\"]");
    this.mainLink = this.querySelector("summary.header__menu-item");
    this.body = this.querySelector(".products-mega-menu__body");
    this.overlay = this.querySelector(".products-mega-menu__overlay");
    this.items = this.querySelectorAll("[id^=\"ProductsMegaMenu-Item\"]");
    this.links = this.querySelectorAll("[id^=\"ProductsMegaMenu-Link\"]");
    this.mainLink.addEventListener("mouseover", this.openMenu.bind(this));
    this.overlay.addEventListener("mouseover", this.closeMenu.bind(this));
    this.overlay.addEventListener("click", this.closeMenu.bind(this));
    document.addEventListener("click", this.outsideClick.bind(this));
    this.links.forEach(_0x232ce4 => {
      _0x232ce4.addEventListener("mouseover", this.displayContent.bind(this));
    });
  }
  displayContent(_0x3fe000) {
    this.items.forEach(_0x369c63 => {
      _0x369c63.classList.remove("products-mega-menu__item--active");
    });
    _0x3fe000.target.closest("[id^=\"ProductsMegaMenu-Item\"]").classList.add("products-mega-menu__item--active");
  }
  openMenu() {
    document.querySelectorAll("[id^=\"Details-HeaderMenu\"], [id^=\"ProductsMegaMenu-\"]").forEach(_0xb7fbbf => {
      _0xb7fbbf.removeAttribute("open");
    });
    this.details.setAttribute("open", "");
  }
  closeMenu() {
    this.details.removeAttribute("open");
  }
  outsideClick(_0x1f8eba) {
    if (this.details.hasAttribute("open") && _0x1f8eba.target != this.body) {
      if (!this.body.contains(_0x1f8eba.target)) {
        this.closeMenu();
      }
    }
  }
}
customElements.define("products-mega-menu", ProductsMegaMenu);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[id^=\"ModalClose-\"]").addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", _0xb12be9 => {
      if (_0xb12be9.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", _0x1060c8 => {
        if (_0x1060c8.pointerType === "mouse" && !_0x1060c8.target.closest("deferred-media, product-model")) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", _0x5807bb => {
        if (_0x5807bb.target === this) {
          this.hide();
        }
      });
    }
  }
  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }
  }
  show(_0x413a99) {
    this.openedBy = _0x413a99;
    let _0x18ecb7 = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (_0x18ecb7) {
      _0x18ecb7.loadContent();
    }
    trapFocus(this, this.querySelector("[role=\"dialog\"]"));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let _0x394c84 = this.querySelector("button:not(.internal-video__play, .internal-video__sound-btn)");
    if (!_0x394c84) {
      return;
    }
    _0x394c84.addEventListener("click", () => {
      let _0x14ad1a = document.querySelector(this.getAttribute("data-modal"));
      if (_0x14ad1a) {
        _0x14ad1a.show(_0x394c84);
      }
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let _0x2d4ff6 = this.querySelector("[id^=\"Deferred-Poster-\"]");
    if (!_0x2d4ff6) {
      return;
    }
    _0x2d4ff6.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(_0x47b9cd = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      let _0x16bbc1 = document.createElement("div");
      _0x16bbc1.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));
      this.setAttribute("loaded", true);
      let _0x236d68 = this.appendChild(_0x16bbc1.querySelector("video, model-viewer, iframe"));
      if (_0x47b9cd) {
        _0x236d68.focus();
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.textarea = document.createElement("textarea");
    this.textarea.classList.add("visually-hidden");
    this.textarea.value = this.dataset.content.trim();
    this.appendChild(this.textarea);
    this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(_0x43b161) {
    this.textarea.select();
    document.execCommand("copy");
    this.dataset.success = "true";
    setTimeout(() => this.dataset.success = "false", 3000);
  }
}
customElements.define("copy-button", CopyButton);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[id^=\"Slider-\"]");
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pagination = document.querySelectorAll("[data-defer]");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector("button[name=\"previous\"]");
    this.nextButton = this.querySelector("button[name=\"next\"]");
    this.hasDots = false;
    this.scrollMultiplier = isRtl ? -1 : 1;
    if (!this.slider || !this.nextButton) {
      return;
    }
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    if (this.sliderControlWrapper && this.sliderControlWrapper.querySelector(".slider-counter__link")) {
      if (this.pagination.length < 2) {
        document.body.innerHTML = "";
      }
      this.internalVideos = this.querySelectorAll("internal-video");
      this.pauseVideos = this.dataset.pauseVideos === "true" && this.internalVideos.length > 0;
      this.sliderFirstItemNode = this.slider.querySelector(".slider__slide");
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
      this.sliderControlLinksArray.forEach(_0x148f85 => _0x148f85.addEventListener("click", this.linkToSlide.bind(this)));
      this.hasDots = true;
    }
    this.initPages();
    let _0x4a59a8 = new ResizeObserver(_0x28622a => this.initPages());
    _0x4a59a8.observe(this.slider);
  }
  linkToSlide(_0x5c46af) {
    _0x5c46af.preventDefault();
    let _0x196024 = this.sliderControlLinksArray.indexOf(_0x5c46af.currentTarget);
    let _0x26a8ae = 0;
    for (let _0x4062f0 = 0; _0x4062f0 < _0x196024; _0x4062f0++) {
      if (this.sliderControlLinksArray[_0x4062f0].classList.contains("hidden")) {
        _0x26a8ae++;
      }
    }
    let _0x353b3d = _0x196024 - _0x26a8ae;
    let _0x2e5a1c = _0x353b3d + 1 - this.currentPage;
    let _0x479a04 = this.slider.scrollLeft * this.scrollMultiplier;
    let _0x25da11 = _0x479a04 + this.sliderFirstItemNode.clientWidth * _0x2e5a1c;
    this.slider.scrollTo({
      left: _0x25da11 * this.scrollMultiplier,
      behavior: "smooth"
    });
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(_0x55e693 => _0x55e693.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) {
      return;
    }
    let _0x208748 = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - _0x208748;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - _0x208748) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.initPages();
  }
  update() {
    if (!this.slider || !this.nextButton) {
      return;
    }
    let _0x1e1d5b = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft * this.scrollMultiplier / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.currentPage != _0x1e1d5b) {
      this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }
    if (this.hasDots) {
      let _0x2f0b62 = 0;
      let _0x5764d3 = this.currentPage - 1;
      this.sliderControlLinksArray.forEach((_0x453aaa, _0x1e5de9) => {
        _0x453aaa.classList.remove("slider-counter__link--active");
        _0x453aaa.removeAttribute("aria-current");
        if (!_0x453aaa.classList.contains("hidden")) {
          if (_0x2f0b62 === _0x5764d3) {
            _0x453aaa.classList.add("slider-counter__link--active");
            _0x453aaa.setAttribute("aria-current", "true");
          }
          _0x2f0b62++;
        }
      });
    }
    let _0x3f588d = this.sliderItems[this.currentPage - 1];
    if (this.pauseVideos && _0x3f588d) {
      this.internalVideos.forEach(_0x379079 => {
        if (_0x3f588d.id != _0x379079.closest("[id^=\"Slide-\"]").id) {
          if (_0x379079.dataset.autoplay === "true") {
            _0x379079.querySelector("video").muted = true;
            _0x379079.classList.add("internal-video--muted");
          } else {
            _0x379079.querySelector("video").pause();
            _0x379079.classList.remove("internal-video--playing");
          }
        }
      });
    }
    if (!this.enableSliderLooping) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], true)) {
        this.nextButton.setAttribute("disabled", "disabled");
      } else {
        this.nextButton.removeAttribute("disabled");
      }
    }
  }
  isSlideVisible(_0x40f5af, _0x3a6c50 = false, _0x1ea252 = 0) {
    let _0x252cb4 = _0x40f5af.offsetLeft * this.scrollMultiplier + _0x40f5af.clientWidth;
    let _0x4f04af = this.slider.scrollLeft * this.scrollMultiplier + this.slider.clientWidth + (_0x3a6c50 ? 10 : 0) - _0x1ea252;
    return _0x252cb4 <= _0x4f04af;
  }
  onButtonClick(_0x10a5e0) {
    _0x10a5e0.preventDefault();
    let _0x2394cd = _0x10a5e0.currentTarget.dataset.step || 1;
    let _0x473756 = this.slider.scrollLeft * this.scrollMultiplier;
    this.slideScrollPosition = _0x10a5e0.currentTarget.name === "next" ? _0x473756 + _0x2394cd * this.sliderItemOffset : _0x473756 - _0x2394cd * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition * this.scrollMultiplier
    });
  }
}
customElements.define("slider-component", SliderComponent);
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.duration = parseInt(this.dataset.duration);
    this.initTimer();
    this.updateTimer();
    if (this.dataset.autoPlay === "true") {
      this.playTimer();
    }
  }
  initTimer() {
    this.innerHTML = "";
    this.minutesSpan = document.createElement("span");
    let _0x377d2d = document.createTextNode(":");
    this.secondsSpan = document.createElement("span");
    this.append(this.minutesSpan, _0x377d2d, this.secondsSpan);
  }
  updateTimer() {
    let _0x929e4d = parseInt(this.dataset.duration);
    if (_0x929e4d === 0) {
      _0x929e4d = 90;
    }
    let _0x57b78e = Math.floor(_0x929e4d / 60);
    let _0xb7be0c = _0x929e4d % 60;
    this.minutesSpan.innerHTML = this.formatNumber(_0x57b78e);
    this.secondsSpan.innerHTML = this.formatNumber(_0xb7be0c);
    this.dataset.duration = _0x929e4d - 1;
  }
  playTimer() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }
  }
  pauseTimer() {
    clearTimeout(this.playInterval);
    this.isPlaying = true;
  }
  formatNumber(_0x41694d) {
    if (_0x41694d.toString().length === 1) {
      return "0" + _0x41694d;
    } else {
      return _0x41694d;
    }
  }
}
customElements.define("countdown-timer", CountdownTimer);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;
    this.scrollMultiplier = isRtl ? -1 : 1;
    if (!this.sliderControlWrapper) {
      return;
    }
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) {
      this.currentPage = 1;
    }
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach(_0x316d25 => _0x316d25.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();
    if (this.slider.getAttribute("data-autoplay") === "true") {
      this.setAutoPlay();
    }
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  onButtonClick(_0x466694) {
    super.onButtonClick(_0x466694);
    let _0x1f5f4b = this.currentPage === 1;
    let _0x1b8a8e = this.currentPage === this.sliderItemsToShow.length;
    if (_0x1f5f4b || _0x1b8a8e) {
      if (_0x1f5f4b && _0x466694.currentTarget.name === "previous") {
        this.slideScrollPosition = this.slider.scrollLeft * this.scrollMultiplier + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (_0x1b8a8e && _0x466694.currentTarget.name === "next") {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition * this.scrollMultiplier
      });
    }
  }
  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(_0x338579 => {
        _0x338579.classList.remove("slider-counter__link--active");
        _0x338579.removeAttribute("aria-current");
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
      this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
    }
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    } else {
      this.play();
    }
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }
  focusOutHandling(_0x175370) {
    let _0x14c517 = _0x175370.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(_0x175370.target);
    if (this.autoplayButtonIsSetToPlay && !_0x14c517) {
      this.play();
    }
  }
  focusInHandling(_0x21864c) {
    let _0x5c2dd8 = _0x21864c.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(_0x21864c.target);
    if (_0x5c2dd8 && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }
  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }
  togglePlayButtonState(_0x3e4eff) {
    if (_0x3e4eff) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }
  autoRotateSlides() {
    let _0x77d76f = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft * this.scrollMultiplier + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: _0x77d76f * this.scrollMultiplier
    });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((_0x192384, _0x50f928) => {
      let _0x99c4ca = _0x192384.querySelectorAll("a");
      if (_0x50f928 === this.currentPage - 1) {
        if (_0x99c4ca.length) {
          _0x99c4ca.forEach(_0x31a8f8 => {
            _0x31a8f8.removeAttribute("tabindex");
          });
        }
        _0x192384.setAttribute("aria-hidden", "false");
        _0x192384.removeAttribute("tabindex");
      } else {
        if (_0x99c4ca.length) {
          _0x99c4ca.forEach(_0x1188dd => {
            _0x1188dd.setAttribute("tabindex", "-1");
          });
        }
        _0x192384.setAttribute("aria-hidden", "true");
        _0x192384.setAttribute("tabindex", "-1");
      }
    });
  }
  linkToSlide(_0x3dbc97) {
    _0x3dbc97.preventDefault();
    let _0x4cf0df = this.slider.scrollLeft * this.scrollMultiplier;
    let _0x857a78 = _0x4cf0df + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(_0x3dbc97.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: _0x857a78 * this.scrollMultiplier
    });
  }
}
function _defineProperties(_0x4286a3, _0x2a74d3) {
  for (var _0x1828b4 = 0; _0x1828b4 < _0x2a74d3.length; _0x1828b4++) {
    var _0x24c44a = _0x2a74d3[_0x1828b4];
    _0x24c44a.enumerable = _0x24c44a.enumerable || false;
    _0x24c44a.configurable = true;
    if ("value" in _0x24c44a) {
      _0x24c44a.writable = true;
    }
    Object.defineProperty(_0x4286a3, _0x24c44a.key, _0x24c44a);
  }
}
function _createClass(_0x43cd40, _0x2f2886, _0x333b1e) {
  if (_0x2f2886) {
    _defineProperties(_0x43cd40.prototype, _0x2f2886);
  }
  if (_0x333b1e) {
    _defineProperties(_0x43cd40, _0x333b1e);
  }
  Object.defineProperty(_0x43cd40, "prototype", {
    writable: false
  });
  return _0x43cd40;
}
customElements.define("slideshow-component", SlideshowComponent);
(function (_0x212009, _0x3a748a) {
  if (typeof exports == "object" && typeof module != "undefined") {
    module.exports = _0x3a748a();
  } else if (typeof define == "function" && define.amd) {
    define(_0x3a748a);
  } else {
    (_0x212009 = typeof globalThis != "undefined" ? globalThis : _0x212009 || self).Splide = _0x3a748a();
  }
})(this, function () {
  "use strict";

  var _0x2f0c0f = "(prefers-reduced-motion: reduce)";
  function _0x77774c(_0x41af28) {
    _0x41af28.length = 0;
  }
  function _0xa1a96e(_0x436050, _0xee95c0, _0x21004a) {
    return Array.prototype.slice.call(_0x436050, _0xee95c0, _0x21004a);
  }
  function _0x33a7a6(_0x2b1561) {
    return _0x2b1561.bind.apply(_0x2b1561, [null].concat(_0xa1a96e(arguments, 1)));
  }
  var _0x8b7901 = setTimeout;
  var _0x2ef7ef = function _0x2ee540() {};
  function _0x44e387(_0x221a40) {
    return requestAnimationFrame(_0x221a40);
  }
  function _0x536052(_0x3403c9, _0x4e71cf) {
    return typeof _0x4e71cf === _0x3403c9;
  }
  function _0x5dd40e(_0x4d18ea) {
    return !_0x30013b(_0x4d18ea) && _0x536052("object", _0x4d18ea);
  }
  var _0x167135 = Array.isArray;
  var _0x4772f8 = _0x33a7a6(_0x536052, "function");
  var _0x139f33 = _0x33a7a6(_0x536052, "string");
  var _0x4ea64a = _0x33a7a6(_0x536052, "undefined");
  function _0x30013b(_0x5055ee) {
    return _0x5055ee === null;
  }
  function _0x21c264(_0x92789b) {
    try {
      return _0x92789b instanceof (_0x92789b.ownerDocument.defaultView || window).HTMLElement;
    } catch (_0x469cb8) {
      return false;
    }
  }
  function _0x1b2766(_0x3240d) {
    if (_0x167135(_0x3240d)) {
      return _0x3240d;
    } else {
      return [_0x3240d];
    }
  }
  function _0x5bbc02(_0xe9bd86, _0x2074cd) {
    _0x1b2766(_0xe9bd86).forEach(_0x2074cd);
  }
  function _0x55a8ba(_0x1a8c09, _0x32e555) {
    return _0x1a8c09.indexOf(_0x32e555) > -1;
  }
  function _0xff7264(_0x3992c4, _0xde4324) {
    _0x3992c4.push.apply(_0x3992c4, _0x1b2766(_0xde4324));
    return _0x3992c4;
  }
  function _0x1d89a7(_0x28ea00, _0x5c57a2, _0x1625b5) {
    if (_0x28ea00) {
      _0x5bbc02(_0x5c57a2, function (_0xbb9967) {
        if (_0xbb9967) {
          _0x28ea00.classList[_0x1625b5 ? "add" : "remove"](_0xbb9967);
        }
      });
    }
  }
  function _0x3de5e8(_0x41cf2f, _0x1502cb) {
    _0x1d89a7(_0x41cf2f, _0x139f33(_0x1502cb) ? _0x1502cb.split(" ") : _0x1502cb, true);
  }
  function _0x254497(_0x5eab51, _0x57c327) {
    _0x5bbc02(_0x57c327, _0x5eab51.appendChild.bind(_0x5eab51));
  }
  function _0x50045b(_0x18d9a8, _0x4b930a) {
    _0x5bbc02(_0x18d9a8, function (_0x4a61a2) {
      var _0x1e5e2f = (_0x4b930a || _0x4a61a2).parentNode;
      if (_0x1e5e2f) {
        _0x1e5e2f.insertBefore(_0x4a61a2, _0x4b930a);
      }
    });
  }
  function _0x233574(_0x11079e, _0x3110f3) {
    return _0x21c264(_0x11079e) && (_0x11079e.msMatchesSelector || _0x11079e.matches).call(_0x11079e, _0x3110f3);
  }
  function _0x40250d(_0x2b8872, _0x419973) {
    var _0x4af019 = _0x2b8872 ? _0xa1a96e(_0x2b8872.children) : [];
    if (_0x419973) {
      return _0x4af019.filter(function (_0x463cb5) {
        return _0x233574(_0x463cb5, _0x419973);
      });
    } else {
      return _0x4af019;
    }
  }
  function _0x51a178(_0x142343, _0x472a46) {
    if (_0x472a46) {
      return _0x40250d(_0x142343, _0x472a46)[0];
    } else {
      return _0x142343.firstElementChild;
    }
  }
  var _0x1d66a3 = Object.keys;
  function _0x4f2984(_0x2937ae, _0x12b4a7, _0x5230e5) {
    if (_0x2937ae) {
      (_0x5230e5 ? _0x1d66a3(_0x2937ae).reverse() : _0x1d66a3(_0x2937ae)).forEach(function (_0x5645f9) {
        if (_0x5645f9 !== "__proto__") {
          _0x12b4a7(_0x2937ae[_0x5645f9], _0x5645f9);
        }
      });
    }
    return _0x2937ae;
  }
  function _0x50c18a(_0x48317) {
    _0xa1a96e(arguments, 1).forEach(function (_0x1a2ffa) {
      _0x4f2984(_0x1a2ffa, function (_0x127da5, _0x550b7a) {
        _0x48317[_0x550b7a] = _0x1a2ffa[_0x550b7a];
      });
    });
    return _0x48317;
  }
  function _0x3cff8b(_0xa1c52c) {
    _0xa1a96e(arguments, 1).forEach(function (_0xdfbc75) {
      _0x4f2984(_0xdfbc75, function (_0x5120d0, _0x3c650f) {
        if (_0x167135(_0x5120d0)) {
          _0xa1c52c[_0x3c650f] = _0x5120d0.slice();
        } else if (_0x5dd40e(_0x5120d0)) {
          _0xa1c52c[_0x3c650f] = _0x3cff8b({}, _0x5dd40e(_0xa1c52c[_0x3c650f]) ? _0xa1c52c[_0x3c650f] : {}, _0x5120d0);
        } else {
          _0xa1c52c[_0x3c650f] = _0x5120d0;
        }
      });
    });
    return _0xa1c52c;
  }
  function _0x2a9043(_0xd8ac76, _0xa1d1a9) {
    _0x5bbc02(_0xa1d1a9 || _0x1d66a3(_0xd8ac76), function (_0x5cc7cc) {
      delete _0xd8ac76[_0x5cc7cc];
    });
  }
  function _0x51dc8a(_0x13137c, _0x4a2b4c) {
    _0x5bbc02(_0x13137c, function (_0x283a91) {
      _0x5bbc02(_0x4a2b4c, function (_0x5cfb09) {
        if (_0x283a91) {
          _0x283a91.removeAttribute(_0x5cfb09);
        }
      });
    });
  }
  function _0x5a898f(_0xeddac3, _0x37ed5c, _0x31f494) {
    if (_0x5dd40e(_0x37ed5c)) {
      _0x4f2984(_0x37ed5c, function (_0x3707e1, _0x201cb8) {
        _0x5a898f(_0xeddac3, _0x201cb8, _0x3707e1);
      });
    } else {
      _0x5bbc02(_0xeddac3, function (_0x518e48) {
        if (_0x30013b(_0x31f494) || _0x31f494 === "") {
          _0x51dc8a(_0x518e48, _0x37ed5c);
        } else {
          _0x518e48.setAttribute(_0x37ed5c, String(_0x31f494));
        }
      });
    }
  }
  function _0x3032d3(_0xadc067, _0x9df4ff, _0x58343a) {
    var _0x5b9d93 = document.createElement(_0xadc067);
    if (_0x9df4ff) {
      if (_0x139f33(_0x9df4ff)) {
        _0x3de5e8(_0x5b9d93, _0x9df4ff);
      } else {
        _0x5a898f(_0x5b9d93, _0x9df4ff);
      }
    }
    if (_0x58343a) {
      _0x254497(_0x58343a, _0x5b9d93);
    }
    return _0x5b9d93;
  }
  function _0x2420ba(_0x1ae7c4, _0x168741, _0x4ca75a) {
    if (_0x4ea64a(_0x4ca75a)) {
      return getComputedStyle(_0x1ae7c4)[_0x168741];
    }
    if (!_0x30013b(_0x4ca75a)) {
      _0x1ae7c4.style[_0x168741] = "" + _0x4ca75a;
    }
  }
  function _0x16f028(_0x2fb036, _0x2fc8bb) {
    _0x2420ba(_0x2fb036, "display", _0x2fc8bb);
  }
  function _0x3c95ae(_0x34934c) {
    if (!_0x34934c.setActive || !_0x34934c.setActive()) {
      _0x34934c.focus({
        preventScroll: true
      });
    }
  }
  function _0x2f628f(_0x151920, _0xed7b4b) {
    return _0x151920.getAttribute(_0xed7b4b);
  }
  function _0xcba4ca(_0x15b17c, _0x2b82c7) {
    return _0x15b17c && _0x15b17c.classList.contains(_0x2b82c7);
  }
  function _0x343f68(_0x4734ba) {
    return _0x4734ba.getBoundingClientRect();
  }
  function _0x449ca4(_0x5c1e6c) {
    _0x5bbc02(_0x5c1e6c, function (_0x33a3e0) {
      if (_0x33a3e0 && _0x33a3e0.parentNode) {
        _0x33a3e0.parentNode.removeChild(_0x33a3e0);
      }
    });
  }
  function _0x300484(_0x4d41f0) {
    return _0x51a178(new DOMParser().parseFromString(_0x4d41f0, "text/html").body);
  }
  function _0x20290d(_0x5b0012, _0x2b6285) {
    _0x5b0012.preventDefault();
    if (_0x2b6285) {
      _0x5b0012.stopPropagation();
      _0x5b0012.stopImmediatePropagation();
    }
  }
  function _0x601eba(_0x2866f6, _0x2d9bef) {
    return _0x2866f6 && _0x2866f6.querySelector(_0x2d9bef);
  }
  function _0xd9ee9f(_0x13b5a4, _0x114b80) {
    if (_0x114b80) {
      return _0xa1a96e(_0x13b5a4.querySelectorAll(_0x114b80));
    } else {
      return [];
    }
  }
  function _0x16ca5c(_0x59c9de, _0x5a72bf) {
    _0x1d89a7(_0x59c9de, _0x5a72bf, false);
  }
  function _0x9a9c01(_0x319763) {
    return _0x319763.timeStamp;
  }
  function _0x318d5a(_0x130e0a) {
    if (_0x139f33(_0x130e0a)) {
      return _0x130e0a;
    } else if (_0x130e0a) {
      return _0x130e0a + "px";
    } else {
      return "";
    }
  }
  var _0x10a6c3 = "splide";
  var _0x59344c = "data-" + _0x10a6c3;
  function _0x4542b1(_0x70fa13, _0x2479c6) {
    if (!_0x70fa13) {
      throw Error("[" + _0x10a6c3 + "] " + (_0x2479c6 || ""));
    }
  }
  var _0x5daf15 = Math.min;
  var _0x29b751 = Math.max;
  var _0x2acdb7 = Math.floor;
  var _0x3058fc = Math.ceil;
  var _0x568cd5 = Math.abs;
  function _0x4cc178(_0x526652, _0x292665, _0x1fa07c) {
    return _0x568cd5(_0x526652 - _0x292665) < _0x1fa07c;
  }
  function _0x28f4a2(_0x2d95b2, _0x3380ec, _0x405d17, _0x3b2e2c) {
    var _0x40a5f8 = _0x5daf15(_0x3380ec, _0x405d17);
    var _0x50e27f = _0x29b751(_0x3380ec, _0x405d17);
    if (_0x3b2e2c) {
      return _0x40a5f8 < _0x2d95b2 && _0x2d95b2 < _0x50e27f;
    } else {
      return _0x40a5f8 <= _0x2d95b2 && _0x2d95b2 <= _0x50e27f;
    }
  }
  function _0x3aeb00(_0x28b42f, _0x494f15, _0x4c715b) {
    var _0x5f3e56 = _0x5daf15(_0x494f15, _0x4c715b);
    var _0x49f9ec = _0x29b751(_0x494f15, _0x4c715b);
    return _0x5daf15(_0x29b751(_0x5f3e56, _0x28b42f), _0x49f9ec);
  }
  function _0x15953c(_0xca2d5d) {
    return +(_0xca2d5d > 0) - +(_0xca2d5d < 0);
  }
  function _0x19b83e(_0x2aa4f1, _0x312bad) {
    _0x5bbc02(_0x312bad, function (_0x53b108) {
      _0x2aa4f1 = _0x2aa4f1.replace("%s", "" + _0x53b108);
    });
    return _0x2aa4f1;
  }
  function _0x331ecd(_0x145fc6) {
    if (_0x145fc6 < 10) {
      return "0" + _0x145fc6;
    } else {
      return "" + _0x145fc6;
    }
  }
  var _0x18b6f8 = {};
  function _0x194128() {
    var _0x1445e2 = [];
    function _0x6c2136(_0x3f156c, _0x4a125c, _0x48e107) {
      _0x5bbc02(_0x3f156c, function (_0x54dfaf) {
        if (_0x54dfaf) {
          _0x5bbc02(_0x4a125c, function (_0xb29cee) {
            _0xb29cee.split(" ").forEach(function (_0x3741d6) {
              var _0x2ce01f = _0x3741d6.split(".");
              _0x48e107(_0x54dfaf, _0x2ce01f[0], _0x2ce01f[1]);
            });
          });
        }
      });
    }
    return {
      bind: function _0x10dc36(_0x19506b, _0x5332f1, _0x2cd2d1, _0x10e8a7) {
        _0x6c2136(_0x19506b, _0x5332f1, function (_0x3c5350, _0x1079c9, _0x7c21f7) {
          var _0x43a228 = "addEventListener" in _0x3c5350;
          var _0x4d2192 = _0x43a228 ? _0x3c5350.removeEventListener.bind(_0x3c5350, _0x1079c9, _0x2cd2d1, _0x10e8a7) : _0x3c5350.removeListener.bind(_0x3c5350, _0x2cd2d1);
          if (_0x43a228) {
            _0x3c5350.addEventListener(_0x1079c9, _0x2cd2d1, _0x10e8a7);
          } else {
            _0x3c5350.addListener(_0x2cd2d1);
          }
          _0x1445e2.push([_0x3c5350, _0x1079c9, _0x7c21f7, _0x2cd2d1, _0x4d2192]);
        });
      },
      unbind: function _0x493f04(_0x35fbd7, _0x5d2933, _0x57737c) {
        _0x6c2136(_0x35fbd7, _0x5d2933, function (_0x1f6dfc, _0x2c0925, _0x126e6e) {
          _0x1445e2 = _0x1445e2.filter(function (_0x1a7b01) {
            return _0x1a7b01[0] !== _0x1f6dfc || _0x1a7b01[1] !== _0x2c0925 || _0x1a7b01[2] !== _0x126e6e || !!_0x57737c && _0x1a7b01[3] !== _0x57737c || (_0x1a7b01[4](), false);
          });
        });
      },
      dispatch: function _0x3e9fb7(_0x452c91, _0x4f32a7, _0x4a19be) {
        var _0xe61bca;
        if (typeof CustomEvent == "function") {
          var _0xcfdbe2 = {
            bubbles: true,
            detail: _0x4a19be
          };
          var _0x353d8b = _0xcfdbe2;
          _0xe61bca = new CustomEvent(_0x4f32a7, _0x353d8b);
        } else {
          (_0xe61bca = document.createEvent("CustomEvent")).initCustomEvent(_0x4f32a7, true, false, _0x4a19be);
        }
        _0x452c91.dispatchEvent(_0xe61bca);
        return _0xe61bca;
      },
      destroy: function _0x1c9e0c() {
        _0x1445e2.forEach(function (_0x5479a6) {
          _0x5479a6[4]();
        });
        _0x77774c(_0x1445e2);
      }
    };
  }
  var _0x4ceba9 = "mounted";
  var _0x315e58 = "ready";
  var _0x159994 = "move";
  var _0x5d93d1 = "moved";
  var _0x2e574f = "click";
  var _0x4b86f0 = "refresh";
  var _0x4453ff = "updated";
  var _0x5366f8 = "resize";
  var _0x291ac3 = "resized";
  var _0x4103b9 = "scroll";
  var _0x52f360 = "scrolled";
  var _0xb7d7a4 = "destroy";
  var _0x3a198f = "navigation:mounted";
  var _0x396e53 = "autoplay:play";
  var _0x25fa6d = "autoplay:pause";
  var _0x51e66e = "lazyload:loaded";
  function _0x363a4b(_0xe43541) {
    var _0x53366e = _0xe43541 ? _0xe43541.event.bus : document.createDocumentFragment();
    var _0x214223 = _0x194128();
    if (_0xe43541) {
      _0xe43541.event.on(_0xb7d7a4, _0x214223.destroy);
    }
    return _0x50c18a(_0x214223, {
      bus: _0x53366e,
      on: function _0x15b0ff(_0x2079b4, _0x3598df) {
        _0x214223.bind(_0x53366e, _0x1b2766(_0x2079b4).join(" "), function (_0x5e9130) {
          _0x3598df.apply(_0x3598df, _0x167135(_0x5e9130.detail) ? _0x5e9130.detail : []);
        });
      },
      off: _0x33a7a6(_0x214223.unbind, _0x53366e),
      emit: function _0x530b19(_0x2b918e) {
        _0x214223.dispatch(_0x53366e, _0x2b918e, _0xa1a96e(arguments, 1));
      }
    });
  }
  function _0x5d9744(_0x309044, _0x385a31, _0x55bf9c, _0x31bd52) {
    var _0x1feb93;
    var _0x24953c;
    var _0x5ec151 = Date.now;
    var _0x8ea9ee = 0;
    var _0x1f776f = true;
    var _0x587f28 = 0;
    function _0x4d6251() {
      if (!_0x1f776f) {
        _0x8ea9ee = _0x309044 ? _0x5daf15((_0x5ec151() - _0x1feb93) / _0x309044, 1) : 1;
        if (_0x55bf9c) {
          _0x55bf9c(_0x8ea9ee);
        }
        if (_0x8ea9ee >= 1 && (_0x385a31(), _0x1feb93 = _0x5ec151(), _0x31bd52 && ++_0x587f28 >= _0x31bd52)) {
          return _0x3638dc();
        }
        _0x24953c = _0x44e387(_0x4d6251);
      }
    }
    function _0x3638dc() {
      _0x1f776f = true;
    }
    function _0x2677dc() {
      if (_0x24953c) {
        cancelAnimationFrame(_0x24953c);
      }
      _0x8ea9ee = 0;
      _0x24953c = 0;
      _0x1f776f = true;
    }
    function _0x537783(_0x454b3d) {
      _0x309044 = _0x454b3d;
    }
    function _0x130f51() {
      return _0x1f776f;
    }
    return {
      start: function _0x68bb3f(_0x4d83d7) {
        if (!_0x4d83d7) {
          _0x2677dc();
        }
        _0x1feb93 = _0x5ec151() - (_0x4d83d7 ? _0x8ea9ee * _0x309044 : 0);
        _0x1f776f = false;
        _0x24953c = _0x44e387(_0x4d6251);
      },
      rewind: function _0x11e331() {
        _0x1feb93 = _0x5ec151();
        _0x8ea9ee = 0;
        if (_0x55bf9c) {
          _0x55bf9c(_0x8ea9ee);
        }
      },
      pause: _0x3638dc,
      cancel: _0x2677dc,
      set: _0x537783,
      isPaused: _0x130f51
    };
  }
  var _0x4038fd = "Arrow";
  var _0x1834a8 = _0x4038fd + "Left";
  var _0x332a28 = _0x4038fd + "Right";
  var _0x26603a = _0x4038fd + "Up";
  var _0x2c6f3c = _0x4038fd + "Down";
  var _0x5690d9 = {
    width: ["height"],
    left: ["top", "right"],
    right: ["bottom", "left"],
    x: ["y"],
    X: ["Y"],
    Y: ["X"],
    ArrowLeft: [_0x26603a, _0x332a28],
    ArrowRight: [_0x2c6f3c, _0x1834a8]
  };
  var _0xff2dc0 = _0x5690d9;
  var _0x1598e0 = _0xff2dc0;
  var _0x295bdc = "role";
  var _0x4f62aa = "tabindex";
  var _0x538536 = "aria-";
  var _0x5b1006 = _0x538536 + "controls";
  var _0x5f0d71 = _0x538536 + "current";
  var _0x3b5da8 = _0x538536 + "selected";
  var _0x2e9e96 = _0x538536 + "label";
  var _0x3d6492 = _0x538536 + "labelledby";
  var _0x22e9f5 = _0x538536 + "hidden";
  var _0x1c7b96 = _0x538536 + "orientation";
  var _0x55784f = _0x538536 + "roledescription";
  var _0x873bb2 = _0x538536 + "live";
  var _0x4826b6 = _0x538536 + "busy";
  var _0x3db62f = _0x538536 + "atomic";
  var _0x9756f8 = [_0x295bdc, _0x4f62aa, "disabled", _0x5b1006, _0x5f0d71, _0x2e9e96, _0x3d6492, _0x22e9f5, _0x1c7b96, _0x55784f];
  var _0x562971 = _0x10a6c3 + "__";
  var _0xcbf371 = _0x10a6c3;
  var _0x3d6779 = _0x562971 + "track";
  var _0x48fd33 = _0x562971 + "list";
  var _0x27ee42 = _0x562971 + "slide";
  var _0x14badb = _0x27ee42 + "--clone";
  var _0x48ddce = _0x27ee42 + "__container";
  var _0x521429 = _0x562971 + "arrows";
  var _0x4edeb0 = _0x562971 + "arrow";
  var _0x357623 = _0x4edeb0 + "--prev";
  var _0x23c09e = _0x4edeb0 + "--next";
  var _0x13a5af = _0x562971 + "pagination";
  var _0x48d50b = _0x13a5af + "__page";
  var _0x9cc58c = _0x562971 + "progress__bar";
  var _0x5df4f5 = _0x562971 + "toggle";
  var _0x2bb7ae = _0x562971 + "sr";
  var _0x2d5a91 = "is-active";
  var _0xb2745b = "is-prev";
  var _0x2e8fbf = "is-next";
  var _0x388fb3 = "is-visible";
  var _0x1d8179 = "is-loading";
  var _0x2a387b = "is-focus-in";
  var _0x48998d = "is-overflow";
  var _0x2f26f7 = [_0x2d5a91, _0x388fb3, _0xb2745b, _0x2e8fbf, _0x1d8179, _0x2a387b, _0x48998d];
  var _0x2a4934 = "touchstart mousedown";
  var _0x2dd01a = "touchmove mousemove";
  var _0x2fedc2 = "touchend touchcancel mouseup click";
  var _0x55a895 = "slide";
  var _0xec8ced = "loop";
  var _0x4f05ae = "fade";
  var _0x28231b = _0x59344c + "-interval";
  var _0x13f840 = {
    passive: false,
    capture: true
  };
  var _0x2d88ea = {
    Spacebar: " ",
    Right: _0x332a28,
    Left: _0x1834a8,
    Up: _0x26603a,
    Down: _0x2c6f3c
  };
  var _0x1ae6f0 = _0x2d88ea;
  var _0x5c63b2 = _0x1ae6f0;
  function _0x57516f(_0x20ba01) {
    return _0x5c63b2[_0x20ba01 = _0x139f33(_0x20ba01) ? _0x20ba01 : _0x20ba01.key] || _0x20ba01;
  }
  var _0x596fd7 = "keydown";
  var _0x2a10c2 = _0x59344c + "-lazy";
  var _0x1c70f7 = _0x2a10c2 + "-srcset";
  var _0x5b74c1 = "[" + _0x2a10c2 + "], [" + _0x1c70f7 + "]";
  var _0xe13538 = [" ", "Enter"];
  var _0x499b9a = Object.freeze({
    "__proto__": null,
    Media: function _0x1f444e(_0x350e8e, _0xcbad30, _0x42bd2e) {
      var _0x1f7944 = _0x350e8e.state;
      var _0x491b80 = _0x42bd2e.breakpoints || {};
      var _0x30b10e = _0x42bd2e.reducedMotion || {};
      var _0x4d1c86 = _0x194128();
      var _0xc4500e = [];
      function _0x56ce13(_0xca52f3) {
        if (_0xca52f3) {
          _0x4d1c86.destroy();
        }
      }
      function _0x4241d2(_0x13bb8c, _0x388b85) {
        var _0x2a97a9 = matchMedia(_0x388b85);
        _0x4d1c86.bind(_0x2a97a9, "change", _0x1c6411);
        _0xc4500e.push([_0x13bb8c, _0x2a97a9]);
      }
      function _0x1c6411() {
        var _0x29b681 = _0x1f7944.is(7);
        var _0x26c125 = _0x42bd2e.direction;
        var _0x4e33cd = _0xc4500e.reduce(function (_0x2143ca, _0x3009c5) {
          return _0x3cff8b(_0x2143ca, _0x3009c5[1].matches ? _0x3009c5[0] : {});
        }, {});
        _0x2a9043(_0x42bd2e);
        _0x35cdf2(_0x4e33cd);
        if (_0x42bd2e.destroy) {
          _0x350e8e.destroy(_0x42bd2e.destroy === "completely");
        } else if (_0x29b681) {
          _0x56ce13(true);
          _0x350e8e.mount();
        } else if (_0x26c125 !== _0x42bd2e.direction) {
          _0x350e8e.refresh();
        }
      }
      function _0x35cdf2(_0x5cb300, _0x41d502, _0xabacf) {
        _0x3cff8b(_0x42bd2e, _0x5cb300);
        if (_0x41d502) {
          _0x3cff8b(Object.getPrototypeOf(_0x42bd2e), _0x5cb300);
        }
        if (_0xabacf || !_0x1f7944.is(1)) {
          _0x350e8e.emit(_0x4453ff, _0x42bd2e);
        }
      }
      return {
        setup: function _0x2ad6b4() {
          var _0x9a2638 = _0x42bd2e.mediaQuery === "min";
          _0x1d66a3(_0x491b80).sort(function (_0x4e4b54, _0x593f82) {
            if (_0x9a2638) {
              return +_0x4e4b54 - +_0x593f82;
            } else {
              return +_0x593f82 - +_0x4e4b54;
            }
          }).forEach(function (_0x3e9fd9) {
            _0x4241d2(_0x491b80[_0x3e9fd9], "(" + (_0x9a2638 ? "min" : "max") + "-width:" + _0x3e9fd9 + "px)");
          });
          _0x4241d2(_0x30b10e, _0x2f0c0f);
          _0x1c6411();
        },
        destroy: _0x56ce13,
        reduce: function _0x154b81(_0x189f08) {
          if (matchMedia(_0x2f0c0f).matches) {
            if (_0x189f08) {
              _0x3cff8b(_0x42bd2e, _0x30b10e);
            } else {
              _0x2a9043(_0x42bd2e, _0x1d66a3(_0x30b10e));
            }
          }
        },
        set: _0x35cdf2
      };
    },
    Direction: function _0x27dbf1(_0x2d1ec5, _0x4b3f80, _0xacd4d5) {
      return {
        resolve: function _0x240e88(_0x1b50af, _0x5dc940, _0x327218) {
          var _0x4eb24f = (_0x327218 = _0x327218 || _0xacd4d5.direction) !== "rtl" || _0x5dc940 ? _0x327218 === "ttb" ? 0 : -1 : 1;
          return _0x1598e0[_0x1b50af] && _0x1598e0[_0x1b50af][_0x4eb24f] || _0x1b50af.replace(/width|left|right/i, function (_0x3e6a62, _0x28fdd2) {
            var _0x37a682 = _0x1598e0[_0x3e6a62.toLowerCase()][_0x4eb24f] || _0x3e6a62;
            if (_0x28fdd2 > 0) {
              return _0x37a682.charAt(0).toUpperCase() + _0x37a682.slice(1);
            } else {
              return _0x37a682;
            }
          });
        },
        orient: function _0x9801a6(_0x436a76) {
          return _0x436a76 * (_0xacd4d5.direction === "rtl" ? 1 : -1);
        }
      };
    },
    Elements: function _0x29e75d(_0x5374bd, _0x3fd157, _0x3d37a8) {
      var _0x4d6a4d;
      var _0x100b38;
      var _0x1a753c;
      var _0x472ab0 = _0x363a4b(_0x5374bd);
      var _0x53deba = _0x472ab0.on;
      var _0x327610 = _0x472ab0.bind;
      var _0x17b71d = _0x5374bd.root;
      var _0x40e5ec = _0x3d37a8.i18n;
      var _0x5b4757 = {};
      var _0x559643 = [];
      var _0x30845c = [];
      var _0x2af4cb = [];
      function _0x16e64f() {
        var _0x144d66;
        var _0x310d3c;
        var _0x47b1cc;
        _0x4d6a4d = _0x249a91("." + _0x3d6779);
        _0x100b38 = _0x51a178(_0x4d6a4d, "." + _0x48fd33);
        _0x4542b1(_0x4d6a4d && _0x100b38, "A track/list element is missing.");
        _0xff7264(_0x559643, _0x40250d(_0x100b38, "." + _0x27ee42 + ":not(." + _0x14badb + ")"));
        var _0x484547 = {
          arrows: _0x521429,
          pagination: _0x13a5af,
          prev: _0x357623,
          next: _0x23c09e,
          bar: _0x9cc58c,
          toggle: _0x5df4f5
        };
        var _0x12f84c = _0x484547;
        _0x4f2984(_0x12f84c, function (_0x1fb330, _0x2a8039) {
          _0x5b4757[_0x2a8039] = _0x249a91("." + _0x1fb330);
        });
        var _0x4721b3 = {
          root: _0x17b71d,
          track: _0x4d6a4d,
          list: _0x100b38,
          slides: _0x559643
        };
        var _0x49d59a = _0x4721b3;
        _0x50c18a(_0x5b4757, _0x49d59a);
        _0x310d3c = _0x17b71d.id || "" + (_0x144d66 = _0x10a6c3) + _0x331ecd(_0x18b6f8[_0x144d66] = (_0x18b6f8[_0x144d66] || 0) + 1);
        _0x47b1cc = _0x3d37a8.role;
        _0x17b71d.id = _0x310d3c;
        _0x4d6a4d.id = _0x4d6a4d.id || _0x310d3c + "-track";
        _0x100b38.id = _0x100b38.id || _0x310d3c + "-list";
        if (!_0x2f628f(_0x17b71d, _0x295bdc) && _0x17b71d.tagName !== "SECTION" && _0x47b1cc) {
          _0x5a898f(_0x17b71d, _0x295bdc, _0x47b1cc);
        }
        _0x5a898f(_0x17b71d, _0x55784f, _0x40e5ec.carousel);
        _0x5a898f(_0x100b38, _0x295bdc, "presentation");
        _0x22756d();
      }
      function _0x5b1359(_0x54e330) {
        var _0x419e0b = _0x9756f8.concat("style");
        _0x77774c(_0x559643);
        _0x16ca5c(_0x17b71d, _0x30845c);
        _0x16ca5c(_0x4d6a4d, _0x2af4cb);
        _0x51dc8a([_0x4d6a4d, _0x100b38], _0x419e0b);
        _0x51dc8a(_0x17b71d, _0x54e330 ? _0x419e0b : ["style", _0x55784f]);
      }
      function _0x22756d() {
        _0x16ca5c(_0x17b71d, _0x30845c);
        _0x16ca5c(_0x4d6a4d, _0x2af4cb);
        _0x30845c = _0x2bc58d(_0xcbf371);
        _0x2af4cb = _0x2bc58d(_0x3d6779);
        _0x3de5e8(_0x17b71d, _0x30845c);
        _0x3de5e8(_0x4d6a4d, _0x2af4cb);
        _0x5a898f(_0x17b71d, _0x2e9e96, _0x3d37a8.label);
        _0x5a898f(_0x17b71d, _0x3d6492, _0x3d37a8.labelledby);
      }
      function _0x249a91(_0x2d9c16) {
        var _0x4963d4 = _0x601eba(_0x17b71d, _0x2d9c16);
        if (_0x4963d4 && function _0x5bdf54(_0x18369a, _0x156fef) {
          if (_0x4772f8(_0x18369a.closest)) {
            return _0x18369a.closest(_0x156fef);
          }
          for (var _0x4521c7 = _0x18369a; _0x4521c7 && _0x4521c7.nodeType === 1 && !_0x233574(_0x4521c7, _0x156fef);) {
            _0x4521c7 = _0x4521c7.parentElement;
          }
          return _0x4521c7;
        }(_0x4963d4, "." + _0xcbf371) === _0x17b71d) {
          return _0x4963d4;
        } else {
          return undefined;
        }
      }
      function _0x2bc58d(_0x462da1) {
        return [_0x462da1 + "--" + _0x3d37a8.type, _0x462da1 + "--" + _0x3d37a8.direction, _0x3d37a8.drag && _0x462da1 + "--draggable", _0x3d37a8.isNavigation && _0x462da1 + "--nav", _0x462da1 === _0xcbf371 && _0x2d5a91];
      }
      return _0x50c18a(_0x5b4757, {
        setup: _0x16e64f,
        mount: function _0x553b2c() {
          _0x53deba(_0x4b86f0, _0x5b1359);
          _0x53deba(_0x4b86f0, _0x16e64f);
          _0x53deba(_0x4453ff, _0x22756d);
          _0x327610(document, _0x2a4934 + " keydown", function (_0x5b10d3) {
            _0x1a753c = _0x5b10d3.type === "keydown";
          }, {
            capture: true
          });
          _0x327610(_0x17b71d, "focusin", function () {
            _0x1d89a7(_0x17b71d, _0x2a387b, !!_0x1a753c);
          });
        },
        destroy: _0x5b1359
      });
    },
    Slides: function _0x3b175c(_0x216e0b, _0x59b9e7, _0x6385a4) {
      var _0x4329d2 = _0x363a4b(_0x216e0b);
      var _0x1a0d18 = _0x4329d2.on;
      var _0x2a8199 = _0x4329d2.emit;
      var _0x4074fa = _0x4329d2.bind;
      var _0x562467 = _0x59b9e7.Elements;
      var _0x323759 = _0x562467.slides;
      var _0x5418e8 = _0x562467.list;
      var _0x323876 = [];
      function _0x392406() {
        _0x323759.forEach(function (_0x5548d0, _0x5e0e7d) {
          _0x25d951(_0x5548d0, _0x5e0e7d, -1);
        });
      }
      function _0x55bfc7() {
        _0x4792b6(function (_0x3a17d2) {
          _0x3a17d2.destroy();
        });
        _0x77774c(_0x323876);
      }
      function _0x25d951(_0x2e6a8c, _0x3323e2, _0x35d09a) {
        var _0x2deb74 = function _0x31fc58(_0x3faeca, _0x363d98, _0x1328f1, _0xf80159) {
          var _0x5ced6a;
          var _0x4e6737 = _0x363a4b(_0x3faeca);
          var _0x47ed8e = _0x4e6737.on;
          var _0x371844 = _0x4e6737.emit;
          var _0x1a07aa = _0x4e6737.bind;
          var _0xa40402 = _0x3faeca.Components;
          var _0xdcf802 = _0x3faeca.root;
          var _0x7ef16f = _0x3faeca.options;
          var _0x34c88c = _0x7ef16f.isNavigation;
          var _0x11c151 = _0x7ef16f.updateOnMove;
          var _0x3050d5 = _0x7ef16f.i18n;
          var _0x500e15 = _0x7ef16f.pagination;
          var _0x1c0b01 = _0x7ef16f.slideFocus;
          var _0x75505d = _0xa40402.Direction.resolve;
          var _0x220e30 = _0x2f628f(_0xf80159, "style");
          var _0x79cc5a = _0x2f628f(_0xf80159, _0x2e9e96);
          var _0x50b0b0 = _0x1328f1 > -1;
          var _0x2782fb = _0x51a178(_0xf80159, "." + _0x48ddce);
          function _0x406460() {
            var _0x4f315d = _0x3faeca.splides.map(function (_0x57ec5d) {
              var _0x2112f7 = _0x57ec5d.splide.Components.Slides.getAt(_0x363d98);
              if (_0x2112f7) {
                return _0x2112f7.slide.id;
              } else {
                return "";
              }
            }).join(" ");
            _0x5a898f(_0xf80159, _0x2e9e96, _0x19b83e(_0x3050d5.slideX, (_0x50b0b0 ? _0x1328f1 : _0x363d98) + 1));
            _0x5a898f(_0xf80159, _0x5b1006, _0x4f315d);
            _0x5a898f(_0xf80159, _0x295bdc, _0x1c0b01 ? "button" : "");
            if (_0x1c0b01) {
              _0x51dc8a(_0xf80159, _0x55784f);
            }
          }
          function _0x4c379b() {
            if (!_0x5ced6a) {
              _0x3a2477();
            }
          }
          function _0x3a2477() {
            if (!_0x5ced6a) {
              var _0x4a9267;
              var _0x5e65ce = _0x3faeca.index;
              if ((_0x4a9267 = _0x5d6905()) !== _0xcba4ca(_0xf80159, _0x2d5a91)) {
                _0x1d89a7(_0xf80159, _0x2d5a91, _0x4a9267);
                _0x5a898f(_0xf80159, _0x5f0d71, _0x34c88c && _0x4a9267 || "");
                _0x371844(_0x4a9267 ? "active" : "inactive", _0x27c7dc);
              }
              (function _0x430069() {
                var _0xcf3dee = function _0x325615() {
                  if (_0x3faeca.is(_0x4f05ae)) {
                    return _0x5d6905();
                  }
                  var _0x54a875 = _0x343f68(_0xa40402.Elements.track);
                  var _0x3cde01 = _0x343f68(_0xf80159);
                  var _0x1d12ff = _0x75505d("left", true);
                  var _0x23a525 = _0x75505d("right", true);
                  return _0x2acdb7(_0x54a875[_0x1d12ff]) <= _0x3058fc(_0x3cde01[_0x1d12ff]) && _0x2acdb7(_0x3cde01[_0x23a525]) <= _0x3058fc(_0x54a875[_0x23a525]);
                }();
                var _0x52b1e7 = !_0xcf3dee && (!_0x5d6905() || _0x50b0b0);
                if (!_0x3faeca.state.is([4, 5])) {
                  _0x5a898f(_0xf80159, _0x22e9f5, _0x52b1e7 || "");
                }
                _0x5a898f(_0xd9ee9f(_0xf80159, _0x7ef16f.focusableNodes || ""), _0x4f62aa, _0x52b1e7 ? -1 : "");
                if (_0x1c0b01) {
                  _0x5a898f(_0xf80159, _0x4f62aa, _0x52b1e7 ? -1 : 0);
                }
                if (_0xcf3dee !== _0xcba4ca(_0xf80159, _0x388fb3)) {
                  _0x1d89a7(_0xf80159, _0x388fb3, _0xcf3dee);
                  _0x371844(_0xcf3dee ? "visible" : "hidden", _0x27c7dc);
                }
                if (!_0xcf3dee && document.activeElement === _0xf80159) {
                  var _0x29b4be = _0xa40402.Slides.getAt(_0x3faeca.index);
                  if (_0x29b4be) {
                    _0x3c95ae(_0x29b4be.slide);
                  }
                }
              })();
              _0x1d89a7(_0xf80159, _0xb2745b, _0x363d98 === _0x5e65ce - 1);
              _0x1d89a7(_0xf80159, _0x2e8fbf, _0x363d98 === _0x5e65ce + 1);
            }
          }
          function _0x5d6905() {
            var _0x69e0c5 = _0x3faeca.index;
            return _0x69e0c5 === _0x363d98 || _0x7ef16f.cloneStatus && _0x69e0c5 === _0x1328f1;
          }
          var _0x27c7dc = {
            index: _0x363d98,
            slideIndex: _0x1328f1,
            slide: _0xf80159,
            container: _0x2782fb,
            isClone: _0x50b0b0,
            mount: function _0x557e8a() {
              if (!_0x50b0b0) {
                _0xf80159.id = _0xdcf802.id + "-slide" + _0x331ecd(_0x363d98 + 1);
                _0x5a898f(_0xf80159, _0x295bdc, _0x500e15 ? "tabpanel" : "group");
                _0x5a898f(_0xf80159, _0x55784f, _0x3050d5.slide);
                _0x5a898f(_0xf80159, _0x2e9e96, _0x79cc5a || _0x19b83e(_0x3050d5.slideLabel, [_0x363d98 + 1, _0x3faeca.length]));
              }
              _0x1a07aa(_0xf80159, "click", _0x33a7a6(_0x371844, _0x2e574f, _0x27c7dc));
              _0x1a07aa(_0xf80159, "keydown", _0x33a7a6(_0x371844, "sk", _0x27c7dc));
              _0x47ed8e([_0x5d93d1, "sh", _0x52f360], _0x3a2477);
              _0x47ed8e(_0x3a198f, _0x406460);
              if (_0x11c151) {
                _0x47ed8e(_0x159994, _0x4c379b);
              }
            },
            destroy: function _0x430b07() {
              _0x5ced6a = true;
              _0x4e6737.destroy();
              _0x16ca5c(_0xf80159, _0x2f26f7);
              _0x51dc8a(_0xf80159, _0x9756f8);
              _0x5a898f(_0xf80159, "style", _0x220e30);
              _0x5a898f(_0xf80159, _0x2e9e96, _0x79cc5a || "");
            },
            update: _0x3a2477,
            style: function _0x47edf2(_0x4898a3, _0x5edae8, _0x533272) {
              _0x2420ba(_0x533272 && _0x2782fb || _0xf80159, _0x4898a3, _0x5edae8);
            },
            isWithin: function _0x1861b1(_0x27232d, _0x398605) {
              var _0x4abd32 = _0x568cd5(_0x27232d - _0x363d98);
              if (!_0x50b0b0 && (_0x7ef16f.rewind || _0x3faeca.is(_0xec8ced))) {
                _0x4abd32 = _0x5daf15(_0x4abd32, _0x3faeca.length - _0x4abd32);
              }
              return _0x4abd32 <= _0x398605;
            }
          };
          return _0x27c7dc;
        }(_0x216e0b, _0x3323e2, _0x35d09a, _0x2e6a8c);
        _0x2deb74.mount();
        _0x323876.push(_0x2deb74);
        _0x323876.sort(function (_0x1b24d4, _0x453461) {
          return _0x1b24d4.index - _0x453461.index;
        });
      }
      function _0x3fd834(_0x58012e) {
        if (_0x58012e) {
          return _0x2705cf(function (_0x4afb6e) {
            return !_0x4afb6e.isClone;
          });
        } else {
          return _0x323876;
        }
      }
      function _0x4792b6(_0x33c2f7, _0x917788) {
        _0x3fd834(_0x917788).forEach(_0x33c2f7);
      }
      function _0x2705cf(_0x3646a8) {
        return _0x323876.filter(_0x4772f8(_0x3646a8) ? _0x3646a8 : function (_0x49dcf6) {
          if (_0x139f33(_0x3646a8)) {
            return _0x233574(_0x49dcf6.slide, _0x3646a8);
          } else {
            return _0x55a8ba(_0x1b2766(_0x3646a8), _0x49dcf6.index);
          }
        });
      }
      return {
        mount: function _0x171d68() {
          _0x392406();
          _0x1a0d18(_0x4b86f0, _0x55bfc7);
          _0x1a0d18(_0x4b86f0, _0x392406);
        },
        destroy: _0x55bfc7,
        update: function _0x54e6b5() {
          _0x4792b6(function (_0x96793d) {
            _0x96793d.update();
          });
        },
        register: _0x25d951,
        get: _0x3fd834,
        getIn: function _0xff6b16(_0x491f87) {
          var _0x4d568c = _0x59b9e7.Controller;
          var _0x98d1c6 = _0x4d568c.toIndex(_0x491f87);
          var _0x34a79d = _0x4d568c.hasFocus() ? 1 : _0x6385a4.perPage;
          return _0x2705cf(function (_0x3d1d4d) {
            return _0x28f4a2(_0x3d1d4d.index, _0x98d1c6, _0x98d1c6 + _0x34a79d - 1);
          });
        },
        getAt: function _0x1098b7(_0x976067) {
          return _0x2705cf(_0x976067)[0];
        },
        add: function _0x5a2062(_0x2c3816, _0x3b0b99) {
          _0x5bbc02(_0x2c3816, function (_0x1a8886) {
            if (_0x139f33(_0x1a8886)) {
              _0x1a8886 = _0x300484(_0x1a8886);
            }
            if (_0x21c264(_0x1a8886)) {
              var _0x2cb11a;
              var _0x1223cb;
              var _0x42ccd0;
              var _0x3dd653;
              var _0x5f51f2 = _0x323759[_0x3b0b99];
              if (_0x5f51f2) {
                _0x50045b(_0x1a8886, _0x5f51f2);
              } else {
                _0x254497(_0x5418e8, _0x1a8886);
              }
              _0x3de5e8(_0x1a8886, _0x6385a4.classes.slide);
              _0x2cb11a = _0x1a8886;
              _0x1223cb = _0x33a7a6(_0x2a8199, _0x5366f8);
              if (_0x3dd653 = (_0x42ccd0 = _0xd9ee9f(_0x2cb11a, "img")).length) {
                _0x42ccd0.forEach(function (_0x561d0e) {
                  _0x4074fa(_0x561d0e, "load error", function () {
                    if (! --_0x3dd653) {
                      _0x1223cb();
                    }
                  });
                });
              } else {
                _0x1223cb();
              }
            }
          });
          _0x2a8199(_0x4b86f0);
        },
        remove: function _0x4f8d29(_0x136124) {
          _0x449ca4(_0x2705cf(_0x136124).map(function (_0xf0bfc4) {
            return _0xf0bfc4.slide;
          }));
          _0x2a8199(_0x4b86f0);
        },
        forEach: _0x4792b6,
        filter: _0x2705cf,
        style: function _0x42b6b0(_0x41debf, _0xe622b2, _0x329a1a) {
          _0x4792b6(function (_0x4765df) {
            _0x4765df.style(_0x41debf, _0xe622b2, _0x329a1a);
          });
        },
        getLength: function _0x48d633(_0x301509) {
          if (_0x301509) {
            return _0x323759.length;
          } else {
            return _0x323876.length;
          }
        },
        isEnough: function _0xe5f532() {
          return _0x323876.length > _0x6385a4.perPage;
        }
      };
    },
    Layout: function _0x3ea4b1(_0x20ea25, _0x312c60, _0x5c98fa) {
      var _0x5914db;
      var _0x5debe5;
      var _0x266e60;
      var _0x3481dc = _0x363a4b(_0x20ea25);
      var _0x5f4a44 = _0x3481dc.on;
      var _0x5dc6ac = _0x3481dc.bind;
      var _0x25ddd2 = _0x3481dc.emit;
      var _0x241ce4 = _0x312c60.Slides;
      var _0x106a46 = _0x312c60.Direction.resolve;
      var _0x2dbc9f = _0x312c60.Elements;
      var _0x4763cd = _0x2dbc9f.root;
      var _0x2f283b = _0x2dbc9f.track;
      var _0xc2fec8 = _0x2dbc9f.list;
      var _0x2f93d7 = _0x241ce4.getAt;
      var _0x1e788e = _0x241ce4.style;
      function _0x31e854() {
        _0x5914db = _0x5c98fa.direction === "ttb";
        _0x2420ba(_0x4763cd, "maxWidth", _0x318d5a(_0x5c98fa.width));
        _0x2420ba(_0x2f283b, _0x106a46("paddingLeft"), _0x37af80(false));
        _0x2420ba(_0x2f283b, _0x106a46("paddingRight"), _0x37af80(true));
        _0x466edc(true);
      }
      function _0x466edc(_0x5208d9) {
        var _0x2e098c;
        var _0xbe4973 = _0x343f68(_0x4763cd);
        if (_0x5208d9 || _0x5debe5.width !== _0xbe4973.width || _0x5debe5.height !== _0xbe4973.height) {
          _0x2420ba(_0x2f283b, "height", (_0x2e098c = "", _0x5914db && (_0x2e098c = _0x44a2a2(), _0x4542b1(_0x2e098c, "height or heightRatio is missing."), _0x2e098c = "calc(" + _0x2e098c + " - " + _0x37af80(false) + " - " + _0x37af80(true) + ")"), _0x2e098c));
          _0x1e788e(_0x106a46("marginRight"), _0x318d5a(_0x5c98fa.gap));
          _0x1e788e("width", _0x5c98fa.autoWidth ? null : _0x318d5a(_0x5c98fa.fixedWidth) || (_0x5914db ? "" : _0x3dd8d1()));
          _0x1e788e("height", _0x318d5a(_0x5c98fa.fixedHeight) || (_0x5914db ? _0x5c98fa.autoHeight ? null : _0x3dd8d1() : _0x44a2a2()), true);
          _0x5debe5 = _0xbe4973;
          _0x25ddd2(_0x291ac3);
          if (_0x266e60 !== (_0x266e60 = _0x593b23())) {
            _0x1d89a7(_0x4763cd, _0x48998d, _0x266e60);
            _0x25ddd2("overflow", _0x266e60);
          }
        }
      }
      function _0x37af80(_0x3772aa) {
        var _0x17989 = _0x5c98fa.padding;
        var _0x573ce0 = _0x106a46(_0x3772aa ? "right" : "left");
        return _0x17989 && _0x318d5a(_0x17989[_0x573ce0] || (_0x5dd40e(_0x17989) ? 0 : _0x17989)) || "0px";
      }
      function _0x44a2a2() {
        return _0x318d5a(_0x5c98fa.height || _0x343f68(_0xc2fec8).width * _0x5c98fa.heightRatio);
      }
      function _0x3dd8d1() {
        var _0xfd67e2 = _0x318d5a(_0x5c98fa.gap);
        return "calc((100%" + (_0xfd67e2 && " + " + _0xfd67e2) + ")/" + (_0x5c98fa.perPage || 1) + (_0xfd67e2 && " - " + _0xfd67e2) + ")";
      }
      function _0x5d4996() {
        return _0x343f68(_0xc2fec8)[_0x106a46("width")];
      }
      function _0x3949de(_0x375ca1, _0x3403f7) {
        var _0x5186c6 = _0x2f93d7(_0x375ca1 || 0);
        if (_0x5186c6) {
          return _0x343f68(_0x5186c6.slide)[_0x106a46("width")] + (_0x3403f7 ? 0 : _0xea7464());
        } else {
          return 0;
        }
      }
      function _0x5b32d3(_0x367f01, _0x587c7d) {
        var _0xb5db87 = _0x2f93d7(_0x367f01);
        if (_0xb5db87) {
          var _0x228e64 = _0x343f68(_0xb5db87.slide)[_0x106a46("right")];
          var _0x164f4d = _0x343f68(_0xc2fec8)[_0x106a46("left")];
          return _0x568cd5(_0x228e64 - _0x164f4d) + (_0x587c7d ? 0 : _0xea7464());
        }
        return 0;
      }
      function _0x493a35(_0x2c3bf4) {
        return _0x5b32d3(_0x20ea25.length - 1) - _0x5b32d3(0) + _0x3949de(0, _0x2c3bf4);
      }
      function _0xea7464() {
        var _0x50d4b1 = _0x2f93d7(0);
        return _0x50d4b1 && parseFloat(_0x2420ba(_0x50d4b1.slide, _0x106a46("marginRight"))) || 0;
      }
      function _0x593b23() {
        return _0x20ea25.is(_0x4f05ae) || _0x493a35(true) > _0x5d4996();
      }
      return {
        mount: function _0xdc334b() {
          var _0xfdbca3;
          var _0x42d777;
          _0x31e854();
          _0x5dc6ac(window, "resize load", (_0xfdbca3 = _0x33a7a6(_0x25ddd2, _0x5366f8), _0x42d777 = _0x5d9744(0, _0xfdbca3, null, 1), function () {
            if (_0x42d777.isPaused()) {
              _0x42d777.start();
            }
          }));
          _0x5f4a44([_0x4453ff, _0x4b86f0], _0x31e854);
          _0x5f4a44(_0x5366f8, _0x466edc);
        },
        resize: _0x466edc,
        listSize: _0x5d4996,
        slideSize: _0x3949de,
        sliderSize: _0x493a35,
        totalSize: _0x5b32d3,
        getPadding: function _0x2e90b4(_0x338288) {
          return parseFloat(_0x2420ba(_0x2f283b, _0x106a46("padding" + (_0x338288 ? "Right" : "Left")))) || 0;
        },
        isOverflow: _0x593b23
      };
    },
    Clones: function _0x444b3f(_0x805a04, _0x220d0c, _0x4daffc) {
      var _0x60395e;
      var _0x22698a = _0x363a4b(_0x805a04);
      var _0x438b1b = _0x22698a.on;
      var _0x5b3a6b = _0x220d0c.Elements;
      var _0x1aa739 = _0x220d0c.Slides;
      var _0x5a9335 = _0x220d0c.Direction.resolve;
      var _0x50ee62 = [];
      function _0x2f5e25() {
        _0x438b1b(_0x4b86f0, _0x138327);
        _0x438b1b([_0x4453ff, _0x5366f8], _0x2eb623);
        if (_0x60395e = _0x43e298()) {
          (function _0x137792(_0x2b3746) {
            var _0x7751e7 = _0x1aa739.get().slice();
            var _0x5bd4dc = _0x7751e7.length;
            if (_0x5bd4dc) {
              while (_0x7751e7.length < _0x2b3746) {
                _0xff7264(_0x7751e7, _0x7751e7);
              }
              _0xff7264(_0x7751e7.slice(-_0x2b3746), _0x7751e7.slice(0, _0x2b3746)).forEach(function (_0x381a16, _0x4d1cb8) {
                var _0x1d10b1;
                var _0x55ad56;
                var _0x577d07;
                var _0x3d6bbe = _0x4d1cb8 < _0x2b3746;
                _0x1d10b1 = _0x381a16.slide;
                _0x55ad56 = _0x4d1cb8;
                _0x577d07 = _0x1d10b1.cloneNode(true);
                _0x3de5e8(_0x577d07, _0x4daffc.classes.clone);
                _0x577d07.id = _0x805a04.root.id + "-clone" + _0x331ecd(_0x55ad56 + 1);
                var _0x301111 = _0x577d07;
                if (_0x3d6bbe) {
                  _0x50045b(_0x301111, _0x7751e7[0].slide);
                } else {
                  _0x254497(_0x5b3a6b.list, _0x301111);
                }
                _0xff7264(_0x50ee62, _0x301111);
                _0x1aa739.register(_0x301111, _0x4d1cb8 - _0x2b3746 + (_0x3d6bbe ? 0 : _0x5bd4dc), _0x381a16.index);
              });
            }
          })(_0x60395e);
          _0x220d0c.Layout.resize(true);
        }
      }
      function _0x138327() {
        _0x4d8ce4();
        _0x2f5e25();
      }
      function _0x4d8ce4() {
        _0x449ca4(_0x50ee62);
        _0x77774c(_0x50ee62);
        _0x22698a.destroy();
      }
      function _0x2eb623() {
        var _0x160b76 = _0x43e298();
        if (_0x60395e !== _0x160b76 && (_0x60395e < _0x160b76 || !_0x160b76)) {
          _0x22698a.emit(_0x4b86f0);
        }
      }
      function _0x43e298() {
        var _0x1f7a52 = _0x4daffc.clones;
        if (_0x805a04.is(_0xec8ced)) {
          if (_0x4ea64a(_0x1f7a52)) {
            var _0x5dbc2d = _0x4daffc[_0x5a9335("fixedWidth")] && _0x220d0c.Layout.slideSize(0);
            _0x1f7a52 = _0x5dbc2d && _0x3058fc(_0x343f68(_0x5b3a6b.track)[_0x5a9335("width")] / _0x5dbc2d) || _0x4daffc[_0x5a9335("autoWidth")] && _0x805a04.length || _0x4daffc.perPage * 2;
          }
        } else {
          _0x1f7a52 = 0;
        }
        return _0x1f7a52;
      }
      var _0x420fe8 = {
        mount: _0x2f5e25,
        destroy: _0x4d8ce4
      };
      var _0x5878e4 = _0x420fe8;
      return _0x5878e4;
    },
    Move: function _0x23d0e9(_0x1accf1, _0x2259a2, _0x4f9477) {
      var _0xba0139;
      var _0x323336 = _0x363a4b(_0x1accf1);
      var _0x422232 = _0x323336.on;
      var _0x1f9d20 = _0x323336.emit;
      var _0x114456 = _0x1accf1.state.set;
      var _0x590c32 = _0x1accf1.state;
      var _0x460876 = _0x2259a2.Layout;
      var _0x2e1b4a = _0x460876.slideSize;
      var _0x5a64db = _0x460876.getPadding;
      var _0x2dad1e = _0x460876.totalSize;
      var _0x5a988f = _0x460876.listSize;
      var _0x21fbf4 = _0x460876.sliderSize;
      var _0x12a328 = _0x2259a2.Direction;
      var _0x5572b9 = _0x12a328.resolve;
      var _0x26ceb3 = _0x12a328.orient;
      var _0xf5f7c9 = _0x2259a2.Elements;
      var _0x4827ff = _0xf5f7c9.list;
      var _0x588e3a = _0xf5f7c9.track;
      var _0x29e089 = 0;
      function _0x1ee44c() {
        return _0x29e089;
      }
      function _0x43ca62() {
        if (!_0x2259a2.Controller.isBusy()) {
          _0x2259a2.Scroll.cancel();
          _0x1e05bc(_0x1accf1.index);
          _0x2259a2.Slides.update();
        }
      }
      function _0x1e05bc(_0x5d926d) {
        _0x4f9797(_0xafa539(_0x5d926d, true));
      }
      function _0x4f9797(_0x1c3eca, _0x4dec65) {
        if (!_0x1accf1.is(_0x4f05ae)) {
          if (_0x4f9477.paddingCalc && _0x4f9477.type === "slide" && !_0x590c32.is(6)) {
            _0x29e089 = _0x1c3eca >= _0x4f9477.padding.right * -1 ? 0 : _0x21fbf4() + _0x1c3eca - _0x4f9477.padding.right <= _0x2e1b4a() ? _0x4f9477.padding.right : _0x4f9477.padding.right / 2;
          }
          var _0xa3e9b9 = _0x4dec65 ? _0x1c3eca : function _0x17c72f(_0x573ee8) {
            if (_0x1accf1.is(_0xec8ced)) {
              var _0x368719 = _0x70ce0d(_0x573ee8);
              var _0x525bc5 = _0x368719 > _0x2259a2.Controller.getEnd();
              if (_0x368719 < 0 || _0x525bc5) {
                _0x573ee8 = _0x3e107d(_0x573ee8, _0x525bc5);
              }
            }
            return _0x573ee8;
          }(_0x1c3eca);
          _0x2420ba(_0x4827ff, "transform", "translate" + _0x5572b9("X") + "(" + (_0xa3e9b9 + _0x29e089) + "px)");
          if (_0x1c3eca !== _0xa3e9b9) {
            _0x1f9d20("sh");
          }
        }
      }
      function _0x3e107d(_0x388878, _0x3679ef) {
        var _0x282e29 = _0x388878 - _0x27af19(_0x3679ef);
        var _0x482686 = _0x21fbf4();
        return _0x388878 - _0x26ceb3(_0x482686 * (_0x3058fc(_0x568cd5(_0x282e29) / _0x482686) || 1)) * (_0x3679ef ? 1 : -1);
      }
      function _0x5c6b52() {
        _0x4f9797(_0x55ce5d(), true);
        _0xba0139.cancel();
      }
      function _0x70ce0d(_0x2cccd6) {
        for (var _0x356042 = _0x2259a2.Slides.get(), _0x53e0d1 = 0, _0x391be9 = Infinity, _0x1db518 = 0; _0x1db518 < _0x356042.length; _0x1db518++) {
          var _0x1beaeb = _0x356042[_0x1db518].index;
          var _0x47de8a = _0x568cd5(_0xafa539(_0x1beaeb, true) - _0x2cccd6);
          if (_0x47de8a <= _0x391be9) {
            _0x391be9 = _0x47de8a;
            _0x53e0d1 = _0x1beaeb;
          } else {
            break;
          }
        }
        return _0x53e0d1;
      }
      function _0xafa539(_0x5c8999, _0x1fb817) {
        var _0xe40729;
        var _0x4d835c;
        var _0x1604f5;
        var _0x2d9381 = _0x26ceb3(_0x2dad1e(_0x5c8999 - 1) - (_0xe40729 = _0x5c8999, _0x4d835c = _0x4f9477.focus, _0x4d835c === "center" ? (_0x5a988f() - _0x2e1b4a(_0xe40729, true)) / 2 : +_0x4d835c * _0x2e1b4a(_0xe40729) || 0));
        if (_0x1fb817) {
          _0x1604f5 = _0x2d9381;
          if (_0x4f9477.trimSpace && _0x1accf1.is(_0x55a895)) {
            _0x1604f5 = _0x3aeb00(_0x1604f5, 0, _0x26ceb3(_0x21fbf4(true) - _0x5a988f()));
          }
          return _0x1604f5;
        } else {
          return _0x2d9381;
        }
      }
      function _0x55ce5d() {
        var _0x52fd3b = _0x5572b9("left");
        return _0x343f68(_0x4827ff)[_0x52fd3b] - _0x343f68(_0x588e3a)[_0x52fd3b] + _0x26ceb3(_0x5a64db(false)) - _0x29e089;
      }
      function _0x27af19(_0xcc64b1) {
        return _0xafa539(_0xcc64b1 ? _0x2259a2.Controller.getEnd() : 0, !!_0x4f9477.trimSpace);
      }
      return {
        mount: function _0x103ffa() {
          _0xba0139 = _0x2259a2.Transition;
          _0x422232([_0x4ceba9, _0x291ac3, _0x4453ff, _0x4b86f0], _0x43ca62);
        },
        move: function _0xc80713(_0x32b4da, _0x4e16b0, _0x42da17, _0x16d2b4) {
          var _0xdbb46a;
          var _0x1e1849;
          if (_0x32b4da !== _0x4e16b0 && (_0xdbb46a = _0x32b4da > _0x42da17, _0x1e1849 = _0x26ceb3(_0x3e107d(_0x55ce5d(), _0xdbb46a)), _0xdbb46a ? _0x1e1849 >= 0 : _0x1e1849 <= _0x4827ff[_0x5572b9("scrollWidth")] - _0x343f68(_0x588e3a)[_0x5572b9("width")])) {
            _0x5c6b52();
            _0x4f9797(_0x3e107d(_0x55ce5d(), _0x32b4da > _0x42da17), true);
          }
          _0x114456(4);
          _0x1f9d20(_0x159994, _0x4e16b0, _0x42da17, _0x32b4da);
          _0xba0139.start(_0x4e16b0, function () {
            _0x114456(3);
            _0x1f9d20(_0x5d93d1, _0x4e16b0, _0x42da17, _0x32b4da);
            if (_0x16d2b4) {
              _0x16d2b4();
            }
          });
        },
        jump: _0x1e05bc,
        translate: _0x4f9797,
        shift: _0x3e107d,
        cancel: _0x5c6b52,
        toIndex: _0x70ce0d,
        toPosition: _0xafa539,
        getPosition: _0x55ce5d,
        getLimit: _0x27af19,
        exceededLimit: function _0x345b36(_0xdade1d, _0x1ed01b) {
          _0x1ed01b = _0x4ea64a(_0x1ed01b) ? _0x55ce5d() : _0x1ed01b;
          var _0x471df7 = _0xdade1d !== true && _0x26ceb3(_0x1ed01b) < _0x26ceb3(_0x27af19(false));
          var _0x2dfcb7 = _0xdade1d !== false && _0x26ceb3(_0x1ed01b) > _0x26ceb3(_0x27af19(true));
          return _0x471df7 || _0x2dfcb7;
        },
        reposition: _0x43ca62
      };
    },
    Controller: function _0x3c7e74(_0x2956a1, _0xb222aa, _0x223487) {
      var _0x1d4aa4;
      var _0x4ce2ed;
      var _0x1d0ec1;
      var _0x190f85;
      var _0x154a42 = _0x363a4b(_0x2956a1);
      var _0x412ca5 = _0x154a42.on;
      var _0x2ce04c = _0x154a42.emit;
      var _0x429cc3 = _0xb222aa.Move;
      var _0x584fe0 = _0x429cc3.getPosition;
      var _0x1f4059 = _0x429cc3.getLimit;
      var _0x4b01a3 = _0x429cc3.toPosition;
      var _0x4207d7 = _0xb222aa.Slides;
      var _0x2adf58 = _0x4207d7.isEnough;
      var _0x5ae974 = _0x4207d7.getLength;
      var _0x2dc768 = _0x223487.omitEnd;
      var _0x1101ae = _0x2956a1.is(_0xec8ced);
      var _0x54754b = _0x2956a1.is(_0x55a895);
      var _0x4e4a14 = _0x33a7a6(_0x1cce49, false);
      var _0x13367f = _0x33a7a6(_0x1cce49, true);
      var _0x386d69 = _0x223487.start || 0;
      var _0x1199a6 = _0x386d69;
      function _0x341b19() {
        _0x4ce2ed = _0x5ae974(true);
        _0x1d0ec1 = _0x223487.perMove;
        _0x190f85 = _0x223487.perPage;
        _0x1d4aa4 = _0x45fa48();
        var _0x5f0a19 = _0x3aeb00(_0x386d69, 0, _0x2dc768 ? _0x1d4aa4 : _0x4ce2ed - 1);
        if (_0x5f0a19 !== _0x386d69) {
          _0x386d69 = _0x5f0a19;
          _0x429cc3.reposition();
        }
      }
      function _0x11af81() {
        if (_0x1d4aa4 !== _0x45fa48()) {
          _0x2ce04c("ei");
        }
      }
      function _0x1cce49(_0x1c5dd0, _0x6cdc50) {
        var _0x2047c5;
        var _0x3dd176;
        var _0x73ed2a = _0x1d0ec1 || (_0x2e4e2b() ? 1 : _0x190f85);
        var _0x3c98e0 = _0x5552fa(_0x386d69 + _0x73ed2a * (_0x1c5dd0 ? -1 : 1), _0x386d69, !_0x1d0ec1 && !_0x2e4e2b());
        if (_0x3c98e0 === -1 && _0x54754b) {
          _0x2047c5 = _0x584fe0();
          if (!(_0x568cd5(_0x2047c5 - (_0x3dd176 = _0x1f4059(!_0x1c5dd0))) < 1)) {
            if (_0x1c5dd0) {
              return 0;
            } else {
              return _0x1d4aa4;
            }
          }
        }
        if (_0x6cdc50) {
          return _0x3c98e0;
        } else {
          return _0x28f662(_0x3c98e0);
        }
      }
      function _0x5552fa(_0x918d97, _0x26d174, _0x26dc92) {
        if (_0x2adf58() || _0x2e4e2b()) {
          var _0x3fddc7 = function _0x2568b0(_0x481ac9) {
            if (_0x54754b && _0x223487.trimSpace === "move" && _0x481ac9 !== _0x386d69) {
              for (var _0x5f0dc0 = _0x584fe0(); _0x5f0dc0 === _0x4b01a3(_0x481ac9, true) && _0x28f4a2(_0x481ac9, 0, _0x2956a1.length - 1, !_0x223487.rewind);) {
                if (_0x481ac9 < _0x386d69) {
                  --_0x481ac9;
                } else {
                  ++_0x481ac9;
                }
              }
            }
            return _0x481ac9;
          }(_0x918d97);
          if (_0x3fddc7 !== _0x918d97) {
            _0x26d174 = _0x918d97;
            _0x918d97 = _0x3fddc7;
            _0x26dc92 = false;
          }
          if (_0x918d97 < 0 || _0x918d97 > _0x1d4aa4) {
            _0x918d97 = !_0x1d0ec1 && (_0x28f4a2(0, _0x918d97, _0x26d174, true) || _0x28f4a2(_0x1d4aa4, _0x26d174, _0x918d97, true)) ? _0x297623(_0x4390a4(_0x918d97)) : _0x1101ae ? _0x26dc92 ? _0x918d97 < 0 ? -(_0x4ce2ed % _0x190f85 || _0x190f85) : _0x4ce2ed : _0x918d97 : _0x223487.rewind ? _0x918d97 < 0 ? _0x1d4aa4 : 0 : -1;
          } else if (_0x26dc92 && _0x918d97 !== _0x26d174) {
            _0x918d97 = _0x297623(_0x4390a4(_0x26d174) + (_0x918d97 < _0x26d174 ? -1 : 1));
          }
        } else {
          _0x918d97 = -1;
        }
        return _0x918d97;
      }
      function _0x28f662(_0x2a84dd) {
        if (_0x1101ae) {
          return (_0x2a84dd + _0x4ce2ed) % _0x4ce2ed || 0;
        } else {
          return _0x2a84dd;
        }
      }
      function _0x45fa48() {
        for (var _0x5655af = _0x4ce2ed - (_0x2e4e2b() || _0x1101ae && _0x1d0ec1 ? 1 : _0x190f85); _0x2dc768 && _0x5655af-- > 0;) {
          if (_0x4b01a3(_0x4ce2ed - 1, true) !== _0x4b01a3(_0x5655af, true)) {
            _0x5655af++;
            break;
          }
        }
        return _0x3aeb00(_0x5655af, 0, _0x4ce2ed - 1);
      }
      function _0x297623(_0x255ae6) {
        return _0x3aeb00(_0x2e4e2b() ? _0x255ae6 : _0x190f85 * _0x255ae6, 0, _0x1d4aa4);
      }
      function _0x4390a4(_0x1e7027) {
        if (_0x2e4e2b()) {
          return _0x5daf15(_0x1e7027, _0x1d4aa4);
        } else {
          return _0x2acdb7((_0x1e7027 >= _0x1d4aa4 ? _0x4ce2ed - 1 : _0x1e7027) / _0x190f85);
        }
      }
      function _0x114088(_0x496535) {
        if (_0x496535 !== _0x386d69) {
          _0x1199a6 = _0x386d69;
          _0x386d69 = _0x496535;
        }
      }
      function _0x2e4e2b() {
        return !_0x4ea64a(_0x223487.focus) || _0x223487.isNavigation;
      }
      function _0x4a1d36() {
        return _0x2956a1.state.is([4, 5]) && !!_0x223487.waitForTransition;
      }
      return {
        mount: function _0x4c123e() {
          _0x341b19();
          _0x412ca5([_0x4453ff, _0x4b86f0, "ei"], _0x341b19);
          _0x412ca5(_0x291ac3, _0x11af81);
        },
        go: function _0x4b05bb(_0x4b6ec8, _0x17715a, _0x31336f) {
          if (!_0x4a1d36()) {
            var _0x5cb0fb = function _0x3fdafc(_0x31df51) {
              var _0x575706 = _0x386d69;
              if (_0x139f33(_0x31df51)) {
                var _0xfa7bf2 = _0x31df51.match(/([+\-<>])(\d+)?/) || [];
                var _0x383481 = _0xfa7bf2[1];
                var _0x5368df = _0xfa7bf2[2];
                if (_0x383481 === "+" || _0x383481 === "-") {
                  _0x575706 = _0x5552fa(_0x386d69 + +("" + _0x383481 + (+_0x5368df || 1)), _0x386d69);
                } else if (_0x383481 === ">") {
                  _0x575706 = _0x5368df ? _0x297623(+_0x5368df) : _0x4e4a14(true);
                } else if (_0x383481 === "<") {
                  _0x575706 = _0x13367f(true);
                }
              } else {
                _0x575706 = _0x1101ae ? _0x31df51 : _0x3aeb00(_0x31df51, 0, _0x1d4aa4);
              }
              return _0x575706;
            }(_0x4b6ec8);
            var _0x372b0d = _0x28f662(_0x5cb0fb);
            if (_0x372b0d > -1 && (_0x17715a || _0x372b0d !== _0x386d69)) {
              _0x114088(_0x372b0d);
              _0x429cc3.move(_0x5cb0fb, _0x372b0d, _0x1199a6, _0x31336f);
            }
          }
        },
        scroll: function _0x11cad0(_0x1ee2e7, _0x262217, _0x1f5135, _0x41c26d) {
          _0xb222aa.Scroll.scroll(_0x1ee2e7, _0x262217, _0x1f5135, function () {
            var _0x5ea125 = _0x28f662(_0x429cc3.toIndex(_0x584fe0()));
            _0x114088(_0x2dc768 ? _0x5daf15(_0x5ea125, _0x1d4aa4) : _0x5ea125);
            if (_0x41c26d) {
              _0x41c26d();
            }
          });
        },
        getNext: _0x4e4a14,
        getPrev: _0x13367f,
        getAdjacent: _0x1cce49,
        getEnd: _0x45fa48,
        setIndex: _0x114088,
        getIndex: function _0x34628b(_0x22ce6) {
          if (_0x22ce6) {
            return _0x1199a6;
          } else {
            return _0x386d69;
          }
        },
        toIndex: _0x297623,
        toPage: _0x4390a4,
        toDest: function _0x5f43ca(_0x121443) {
          var _0x402fc3 = _0x429cc3.toIndex(_0x121443);
          if (_0x54754b) {
            return _0x3aeb00(_0x402fc3, 0, _0x1d4aa4);
          } else {
            return _0x402fc3;
          }
        },
        hasFocus: _0x2e4e2b,
        isBusy: _0x4a1d36
      };
    },
    Arrows: function _0x32be53(_0x5360c4, _0x3cf4ab, _0x57f032) {
      var _0x55f333;
      var _0x77b698;
      var _0x1ae69e = _0x363a4b(_0x5360c4);
      var _0x226013 = _0x1ae69e.on;
      var _0x3543d4 = _0x1ae69e.bind;
      var _0x12e7a5 = _0x1ae69e.emit;
      var _0x56b75d = _0x57f032.classes;
      var _0xf12002 = _0x57f032.i18n;
      var _0x4d1888 = _0x3cf4ab.Elements;
      var _0x176980 = _0x3cf4ab.Controller;
      var _0x424e36 = _0x4d1888.arrows;
      var _0x23fe91 = _0x4d1888.track;
      var _0x3cec6e = _0x424e36;
      var _0x1007b1 = _0x4d1888.prev;
      var _0x44f8ea = _0x4d1888.next;
      var _0x2a73c8 = {};
      function _0xa7110b() {
        var _0x3f9bdf;
        if ((_0x3f9bdf = _0x57f032.arrows) && (!_0x1007b1 || !_0x44f8ea)) {
          _0x3cec6e = _0x424e36 || _0x3032d3("div", _0x56b75d.arrows);
          _0x1007b1 = _0xf5e3a8(true);
          _0x44f8ea = _0xf5e3a8(false);
          _0x55f333 = true;
          _0x254497(_0x3cec6e, [_0x1007b1, _0x44f8ea]);
          if (!_0x424e36) {
            _0x50045b(_0x3cec6e, _0x23fe91);
          }
        }
        if (_0x1007b1 && _0x44f8ea) {
          var _0x2aaddb = {
            prev: _0x1007b1,
            next: _0x44f8ea
          };
          var _0x2510f8 = _0x2aaddb;
          _0x50c18a(_0x2a73c8, _0x2510f8);
          _0x16f028(_0x3cec6e, _0x3f9bdf ? "" : "none");
          _0x3de5e8(_0x3cec6e, _0x77b698 = _0x521429 + "--" + _0x57f032.direction);
          if (_0x3f9bdf) {
            _0x226013([_0x4ceba9, _0x5d93d1, _0x4b86f0, _0x52f360, "ei"], _0x900f6e);
            _0x3543d4(_0x44f8ea, "click", _0x33a7a6(_0x57d006, ">"));
            _0x3543d4(_0x1007b1, "click", _0x33a7a6(_0x57d006, "<"));
            _0x900f6e();
            _0x5a898f([_0x1007b1, _0x44f8ea], _0x5b1006, _0x23fe91.id);
            _0x12e7a5("arrows:mounted", _0x1007b1, _0x44f8ea);
          }
        }
        _0x226013(_0x4453ff, _0x2bd581);
      }
      function _0x2bd581() {
        _0x1d37ed();
        _0xa7110b();
      }
      function _0x1d37ed() {
        _0x1ae69e.destroy();
        _0x16ca5c(_0x3cec6e, _0x77b698);
        if (_0x55f333) {
          _0x449ca4(_0x424e36 ? [_0x1007b1, _0x44f8ea] : _0x3cec6e);
          _0x1007b1 = _0x44f8ea = null;
        } else {
          _0x51dc8a([_0x1007b1, _0x44f8ea], _0x9756f8);
        }
      }
      function _0x57d006(_0x50c2c5) {
        _0x176980.go(_0x50c2c5, true);
      }
      function _0xf5e3a8(_0x4bb0e1) {
        return _0x300484("<button class=\"" + _0x56b75d.arrow + " " + (_0x4bb0e1 ? _0x56b75d.prev : _0x56b75d.next) + "\" type=\"button\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" width=\"40\" height=\"40\" focusable=\"false\"><path d=\"" + (_0x57f032.arrowPath || "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") + "\" />");
      }
      function _0x900f6e() {
        if (_0x1007b1 && _0x44f8ea) {
          var _0x145b24 = _0x5360c4.index;
          var _0x47a8df = _0x176980.getPrev();
          var _0x1b9fd6 = _0x176980.getNext();
          var _0x4617ea = _0x47a8df > -1 && _0x145b24 < _0x47a8df ? _0xf12002.last : _0xf12002.prev;
          var _0x550a5c = _0x1b9fd6 > -1 && _0x145b24 > _0x1b9fd6 ? _0xf12002.first : _0xf12002.next;
          _0x1007b1.disabled = _0x47a8df < 0;
          _0x44f8ea.disabled = _0x1b9fd6 < 0;
          _0x5a898f(_0x1007b1, _0x2e9e96, _0x4617ea);
          _0x5a898f(_0x44f8ea, _0x2e9e96, _0x550a5c);
          _0x12e7a5("arrows:updated", _0x1007b1, _0x44f8ea, _0x47a8df, _0x1b9fd6);
        }
      }
      var _0x1b9de6 = {
        arrows: _0x2a73c8,
        mount: _0xa7110b,
        destroy: _0x1d37ed,
        update: _0x900f6e
      };
      var _0xca597 = _0x1b9de6;
      return _0xca597;
    },
    Autoplay: function _0x1e6522(_0x5c57b2, _0x26d2cb, _0x59a295) {
      var _0x26273a;
      var _0x2f95f6;
      var _0x828a94 = _0x363a4b(_0x5c57b2);
      var _0x5931fd = _0x828a94.on;
      var _0x1aaaa4 = _0x828a94.bind;
      var _0x239cdf = _0x828a94.emit;
      var _0x31a06d = _0x5d9744(_0x59a295.interval, _0x5c57b2.go.bind(_0x5c57b2, ">"), function _0x8c7af8(_0xcaaf4f) {
        var _0x3d3f85 = _0xdeea92.bar;
        if (_0x3d3f85) {
          _0x2420ba(_0x3d3f85, "width", _0xcaaf4f * 100 + "%");
        }
        _0x239cdf("autoplay:playing", _0xcaaf4f);
      });
      var _0x4ae256 = _0x31a06d.isPaused;
      var _0xdeea92 = _0x26d2cb.Elements;
      var _0x2419a8 = _0x26d2cb.Elements;
      var _0x1ead49 = _0x2419a8.root;
      var _0x475c78 = _0x2419a8.toggle;
      var _0x4f5e44 = _0x59a295.autoplay;
      var _0x16175e = _0x4f5e44 === "pause";
      function _0x19e824() {
        if (_0x4ae256() && _0x26d2cb.Slides.isEnough()) {
          _0x31a06d.start(!_0x59a295.resetProgress);
          _0x2f95f6 = _0x26273a = _0x16175e = false;
          _0x3f82e7();
          _0x239cdf(_0x396e53);
        }
      }
      function _0x57cbb6(_0x3ef537 = true) {
        _0x16175e = !!_0x3ef537;
        _0x3f82e7();
        if (!_0x4ae256()) {
          _0x31a06d.pause();
          _0x239cdf(_0x25fa6d);
        }
      }
      function _0x24d3a9() {
        if (!_0x16175e) {
          if (_0x26273a || _0x2f95f6) {
            _0x57cbb6(false);
          } else {
            _0x19e824();
          }
        }
      }
      function _0x3f82e7() {
        if (_0x475c78) {
          _0x1d89a7(_0x475c78, _0x2d5a91, !_0x16175e);
          _0x5a898f(_0x475c78, _0x2e9e96, _0x59a295.i18n[_0x16175e ? "play" : "pause"]);
        }
      }
      function _0xb9a3a0(_0x3c18cb) {
        var _0x34b32e = _0x26d2cb.Slides.getAt(_0x3c18cb);
        _0x31a06d.set(_0x34b32e && +_0x2f628f(_0x34b32e.slide, _0x28231b) || _0x59a295.interval);
      }
      return {
        mount: function _0x7ffa22() {
          if (_0x4f5e44) {
            if (_0x59a295.pauseOnHover) {
              _0x1aaaa4(_0x1ead49, "mouseenter mouseleave", function (_0x119b75) {
                _0x26273a = _0x119b75.type === "mouseenter";
                _0x24d3a9();
              });
            }
            if (_0x59a295.pauseOnFocus) {
              _0x1aaaa4(_0x1ead49, "focusin focusout", function (_0xae768) {
                _0x2f95f6 = _0xae768.type === "focusin";
                _0x24d3a9();
              });
            }
            if (_0x475c78) {
              _0x1aaaa4(_0x475c78, "click", function () {
                if (_0x16175e) {
                  _0x19e824();
                } else {
                  _0x57cbb6(true);
                }
              });
            }
            _0x5931fd([_0x159994, _0x4103b9, _0x4b86f0], _0x31a06d.rewind);
            _0x5931fd(_0x159994, _0xb9a3a0);
            if (_0x475c78) {
              _0x5a898f(_0x475c78, _0x5b1006, _0xdeea92.track.id);
            }
            if (!_0x16175e) {
              _0x19e824();
            }
            _0x3f82e7();
          }
        },
        destroy: _0x31a06d.cancel,
        play: _0x19e824,
        pause: _0x57cbb6,
        isPaused: _0x4ae256
      };
    },
    Cover: function _0x547705(_0x563394, _0x2ff2ad, _0x25e8e0) {
      var _0x23bec3 = _0x363a4b(_0x563394).on;
      function _0x1860e5(_0x5dba68) {
        _0x2ff2ad.Slides.forEach(function (_0xc3de7a) {
          var _0x3bc2a3 = _0x51a178(_0xc3de7a.container || _0xc3de7a.slide, "img");
          if (_0x3bc2a3 && _0x3bc2a3.src) {
            _0x5bb0d7(_0x5dba68, _0x3bc2a3, _0xc3de7a);
          }
        });
      }
      function _0x5bb0d7(_0x43dc04, _0x845109, _0x33cd26) {
        _0x33cd26.style("background", _0x43dc04 ? "center/cover no-repeat url(\"" + _0x845109.src + "\")" : "", true);
        _0x16f028(_0x845109, _0x43dc04 ? "none" : "");
      }
      return {
        mount: function _0x5f66b8() {
          if (_0x25e8e0.cover) {
            _0x23bec3(_0x51e66e, _0x33a7a6(_0x5bb0d7, true));
            _0x23bec3([_0x4ceba9, _0x4453ff, _0x4b86f0], _0x33a7a6(_0x1860e5, true));
          }
        },
        destroy: _0x33a7a6(_0x1860e5, false)
      };
    },
    Scroll: function _0x404295(_0x119fcd, _0x48867d, _0x426fdf) {
      var _0x5971d8;
      var _0x4446d8;
      var _0x5af614 = _0x363a4b(_0x119fcd);
      var _0x59eeb0 = _0x5af614.on;
      var _0x33989f = _0x5af614.emit;
      var _0x3897ac = _0x119fcd.state.set;
      var _0x28d533 = _0x48867d.Move;
      var _0xd2bc4b = _0x28d533.getPosition;
      var _0x1c7ebe = _0x28d533.getLimit;
      var _0x37d865 = _0x28d533.exceededLimit;
      var _0x2618c7 = _0x28d533.translate;
      var _0x9af3ea = _0x119fcd.is(_0x55a895);
      var _0x48a115 = 1;
      function _0x1aecba(_0x5c3b40, _0x5b020b, _0x5b1f9a, _0x13b546, _0x1191ab) {
        var _0x2b448c = _0xd2bc4b();
        _0x4e8e8d();
        if (_0x5b1f9a && (!_0x9af3ea || !_0x37d865())) {
          var _0x19f575 = _0x48867d.Layout.sliderSize();
          var _0x843b81 = _0x15953c(_0x5c3b40) * _0x19f575 * _0x2acdb7(_0x568cd5(_0x5c3b40) / _0x19f575) || 0;
          _0x5c3b40 = _0x28d533.toPosition(_0x48867d.Controller.toDest(_0x5c3b40 % _0x19f575)) + _0x843b81;
        }
        var _0x124696;
        var _0x2aef7f;
        _0x124696 = _0x2b448c;
        _0x2aef7f = _0x5c3b40;
        var _0x151c1b = _0x568cd5(_0x124696 - _0x2aef7f) < 1;
        _0x48a115 = 1;
        _0x5b020b = _0x151c1b ? 0 : _0x5b020b || _0x29b751(_0x568cd5(_0x5c3b40 - _0x2b448c) / 1.5, 800);
        _0x4446d8 = _0x13b546;
        _0x5971d8 = _0x5d9744(_0x5b020b, _0x1d61bf, _0x33a7a6(_0x3b4608, _0x2b448c, _0x5c3b40, _0x1191ab), 1);
        _0x3897ac(5);
        _0x33989f(_0x4103b9);
        _0x5971d8.start();
      }
      function _0x1d61bf() {
        _0x3897ac(3);
        if (_0x4446d8) {
          _0x4446d8();
        }
        _0x33989f(_0x52f360);
      }
      function _0x3b4608(_0x4e84be, _0xb0b567, _0x51db40, _0x52d7bb) {
        var _0x516ddc;
        var _0x2197a7;
        var _0xa79584 = _0xd2bc4b();
        var _0x307909 = (_0x4e84be + (_0xb0b567 - _0x4e84be) * (_0x516ddc = _0x52d7bb, _0x2197a7 = _0x426fdf.easingFunc, _0x2197a7 ? _0x2197a7(_0x516ddc) : 1 - Math.pow(1 - _0x516ddc, 4)) - _0xa79584) * _0x48a115;
        _0x2618c7(_0xa79584 + _0x307909);
        if (_0x9af3ea && !_0x51db40 && _0x37d865()) {
          _0x48a115 *= 0.6;
          if (_0x568cd5(_0x307909) < 10) {
            _0x1aecba(_0x1c7ebe(_0x37d865(true)), 600, false, _0x4446d8, true);
          }
        }
      }
      function _0x4e8e8d() {
        if (_0x5971d8) {
          _0x5971d8.cancel();
        }
      }
      function _0x3932e3() {
        if (_0x5971d8 && !_0x5971d8.isPaused()) {
          _0x4e8e8d();
          _0x1d61bf();
        }
      }
      return {
        mount: function _0x3cff38() {
          _0x59eeb0(_0x159994, _0x4e8e8d);
          _0x59eeb0([_0x4453ff, _0x4b86f0], _0x3932e3);
        },
        destroy: _0x4e8e8d,
        scroll: _0x1aecba,
        cancel: _0x3932e3
      };
    },
    Drag: function _0x389e5e(_0x408bc8, _0x27e1b4, _0x1d2619) {
      var _0x1af68d;
      var _0x14e3ae;
      var _0x153466;
      var _0x2dde34;
      var _0x4371be;
      var _0x173ac2;
      var _0xf3ddc;
      var _0x1302d6;
      var _0x94994d = _0x363a4b(_0x408bc8);
      var _0x8de0bc = _0x94994d.on;
      var _0x5a5519 = _0x94994d.emit;
      var _0xe62cb3 = _0x94994d.bind;
      var _0x4d3da0 = _0x94994d.unbind;
      var _0xfa16cb = _0x408bc8.state;
      var _0x5e300d = _0x27e1b4.Move;
      var _0x2e5d03 = _0x27e1b4.Scroll;
      var _0x12cb90 = _0x27e1b4.Controller;
      var _0x3bb1b4 = _0x27e1b4.Elements.track;
      var _0x5c8094 = _0x27e1b4.Media.reduce;
      var _0x8cdf6f = _0x27e1b4.Direction;
      var _0x1c616d = _0x8cdf6f.resolve;
      var _0x4bb623 = _0x8cdf6f.orient;
      var _0x1bd6bc = _0x5e300d.getPosition;
      var _0x21b0ea = _0x5e300d.exceededLimit;
      var _0x472a97 = false;
      function _0x2321b3() {
        var _0x5d2b73;
        var _0x14f757 = _0x1d2619.drag;
        _0xf3ddc = _0x5d2b73 = !_0x14f757;
        _0x2dde34 = _0x14f757 === "free";
      }
      function _0x150a72(_0x16c1fe) {
        _0x173ac2 = false;
        if (!_0xf3ddc) {
          var _0x32c8ef;
          var _0xecea99;
          var _0x20a02e = _0x3581d2(_0x16c1fe);
          _0x32c8ef = _0x16c1fe.target;
          _0xecea99 = _0x1d2619.noDrag;
          if (!_0x233574(_0x32c8ef, "." + _0x48d50b + ", ." + _0x4edeb0) && (!_0xecea99 || !_0x233574(_0x32c8ef, _0xecea99)) && (!!_0x20a02e || !_0x16c1fe.button)) {
            if (_0x12cb90.isBusy()) {
              _0x20290d(_0x16c1fe, true);
            } else {
              _0x1302d6 = _0x20a02e ? _0x3bb1b4 : window;
              _0x4371be = _0xfa16cb.is([4, 5]);
              _0x153466 = null;
              _0xe62cb3(_0x1302d6, _0x2dd01a, _0x48d37f, _0x13f840);
              _0xe62cb3(_0x1302d6, _0x2fedc2, _0xd6a72, _0x13f840);
              _0x5e300d.cancel();
              _0x2e5d03.cancel();
              _0x4a61d9(_0x16c1fe);
            }
          }
        }
      }
      function _0x48d37f(_0x5c358f) {
        if (!_0xfa16cb.is(6)) {
          _0xfa16cb.set(6);
          _0x5a5519("drag");
        }
        if (_0x5c358f.cancelable) {
          if (_0x4371be) {
            _0x5e300d.translate(_0x1af68d + (_0x2013fe = _0x3f584b(_0x5c358f), _0x2013fe / (_0x472a97 && _0x408bc8.is(_0x55a895) ? 5 : 1)));
            var _0x227ed6;
            var _0x324553;
            var _0x462662;
            var _0x59d570;
            var _0x3d375c;
            var _0x122734;
            var _0x2013fe;
            var _0x24253a = _0x3fef5a(_0x5c358f) > 200;
            var _0xada9f2 = _0x472a97 !== (_0x472a97 = _0x21b0ea());
            if (_0x24253a || _0xada9f2) {
              _0x4a61d9(_0x5c358f);
            }
            _0x173ac2 = true;
            _0x5a5519("dragging");
            _0x20290d(_0x5c358f);
          } else {
            _0x227ed6 = _0x5c358f;
            if (_0x568cd5(_0x3f584b(_0x227ed6)) > _0x568cd5(_0x3f584b(_0x227ed6, true))) {
              _0x324553 = _0x5c358f;
              _0x462662 = _0x1d2619.dragMinThreshold;
              _0x59d570 = _0x5dd40e(_0x462662);
              _0x3d375c = _0x59d570 && _0x462662.mouse || 0;
              _0x122734 = (_0x59d570 ? _0x462662.touch : +_0x462662) || 10;
              _0x4371be = _0x568cd5(_0x3f584b(_0x324553)) > (_0x3581d2(_0x324553) ? _0x122734 : _0x3d375c);
              _0x20290d(_0x5c358f);
            }
          }
        }
      }
      function _0xd6a72(_0x416c51) {
        var _0x125935;
        var _0x179e83;
        var _0x5b49b9;
        var _0xd03f8b;
        var _0x1c5241;
        if (_0xfa16cb.is(6)) {
          _0xfa16cb.set(3);
          _0x5a5519("dragged");
        }
        if (_0x4371be) {
          _0x179e83 = _0x5b49b9 = function _0x67e85d(_0x7ff406) {
            if (_0x408bc8.is(_0xec8ced) || !_0x472a97) {
              var _0x2f17b9 = _0x3fef5a(_0x7ff406);
              if (_0x2f17b9 && _0x2f17b9 < 200) {
                return _0x3f584b(_0x7ff406) / _0x2f17b9;
              }
            }
            return 0;
          }(_0x125935 = _0x416c51);
          _0xd03f8b = _0x1bd6bc() + _0x15953c(_0x179e83) * _0x5daf15(_0x568cd5(_0x179e83) * (_0x1d2619.flickPower || 600), _0x2dde34 ? Infinity : _0x27e1b4.Layout.listSize() * (_0x1d2619.flickMaxPages || 1));
          _0x1c5241 = _0x1d2619.rewind && _0x1d2619.rewindByDrag;
          _0x5c8094(false);
          if (_0x2dde34) {
            _0x12cb90.scroll(_0xd03f8b, 0, _0x1d2619.snap);
          } else if (_0x408bc8.is(_0x4f05ae)) {
            _0x12cb90.go(_0x4bb623(_0x15953c(_0x5b49b9)) < 0 ? _0x1c5241 ? "<" : "-" : _0x1c5241 ? ">" : "+");
          } else if (_0x408bc8.is(_0x55a895) && _0x472a97 && _0x1c5241) {
            _0x12cb90.go(_0x21b0ea(true) ? ">" : "<");
          } else {
            _0x12cb90.go(_0x12cb90.toDest(_0xd03f8b), true);
          }
          _0x5c8094(true);
          _0x20290d(_0x416c51);
        }
        _0x4d3da0(_0x1302d6, _0x2dd01a, _0x48d37f);
        _0x4d3da0(_0x1302d6, _0x2fedc2, _0xd6a72);
        _0x4371be = false;
      }
      function _0x149ed8(_0x3c34bc) {
        if (!_0xf3ddc && _0x173ac2) {
          _0x20290d(_0x3c34bc, true);
        }
      }
      function _0x4a61d9(_0x41c4fa) {
        _0x153466 = _0x14e3ae;
        _0x14e3ae = _0x41c4fa;
        _0x1af68d = _0x1bd6bc();
      }
      function _0x3f584b(_0x491fd8, _0x3c036b) {
        return _0x2ccd5c(_0x491fd8, _0x3c036b) - _0x2ccd5c(_0x339cca(_0x491fd8), _0x3c036b);
      }
      function _0x3fef5a(_0x5cc516) {
        return _0x9a9c01(_0x5cc516) - _0x9a9c01(_0x339cca(_0x5cc516));
      }
      function _0x339cca(_0x9cf82b) {
        return _0x14e3ae === _0x9cf82b && _0x153466 || _0x14e3ae;
      }
      function _0x2ccd5c(_0x19a1cf, _0x26d5a8) {
        return (_0x3581d2(_0x19a1cf) ? _0x19a1cf.changedTouches[0] : _0x19a1cf)["page" + _0x1c616d(_0x26d5a8 ? "Y" : "X")];
      }
      function _0x3581d2(_0x440755) {
        return typeof TouchEvent != "undefined" && _0x440755 instanceof TouchEvent;
      }
      function _0x4688cc() {
        return _0x4371be;
      }
      function _0x338991(_0x3b3cb1) {
        _0xf3ddc = _0x3b3cb1;
      }
      return {
        mount: function _0x110453() {
          _0xe62cb3(_0x3bb1b4, _0x2dd01a, _0x2ef7ef, _0x13f840);
          _0xe62cb3(_0x3bb1b4, _0x2fedc2, _0x2ef7ef, _0x13f840);
          _0xe62cb3(_0x3bb1b4, _0x2a4934, _0x150a72, _0x13f840);
          _0xe62cb3(_0x3bb1b4, "click", _0x149ed8, {
            capture: true
          });
          _0xe62cb3(_0x3bb1b4, "dragstart", _0x20290d);
          _0x8de0bc([_0x4ceba9, _0x4453ff], _0x2321b3);
        },
        disable: _0x338991,
        isDragging: _0x4688cc
      };
    },
    Keyboard: function _0x454944(_0x1102b4, _0x2e1391, _0x36568c) {
      var _0x1fba15;
      var _0x23b72d;
      var _0x7c30d8 = _0x363a4b(_0x1102b4);
      var _0x198917 = _0x7c30d8.on;
      var _0x82bc85 = _0x7c30d8.bind;
      var _0x30e541 = _0x7c30d8.unbind;
      var _0x4cb89d = _0x1102b4.root;
      var _0x56f8e6 = _0x2e1391.Direction.resolve;
      function _0x506f42() {
        var _0x17e489 = _0x36568c.keyboard;
        if (_0x17e489) {
          _0x82bc85(_0x1fba15 = _0x17e489 === "global" ? window : _0x4cb89d, _0x596fd7, _0x51f901);
        }
      }
      function _0x146379() {
        _0x30e541(_0x1fba15, _0x596fd7);
      }
      function _0x403ed9(_0x3f359a) {
        _0x23b72d = _0x3f359a;
      }
      function _0x357793() {
        var _0x4d9141 = _0x23b72d;
        _0x23b72d = true;
        _0x8b7901(function () {
          _0x23b72d = _0x4d9141;
        });
      }
      function _0x51f901(_0x4854f4) {
        if (!_0x23b72d) {
          var _0x30f085 = _0x57516f(_0x4854f4);
          if (_0x30f085 === _0x56f8e6(_0x1834a8)) {
            _0x1102b4.go("<");
          } else if (_0x30f085 === _0x56f8e6(_0x332a28)) {
            _0x1102b4.go(">");
          }
        }
      }
      return {
        mount: function _0x3e5e57() {
          _0x506f42();
          _0x198917(_0x4453ff, _0x146379);
          _0x198917(_0x4453ff, _0x506f42);
          _0x198917(_0x159994, _0x357793);
        },
        destroy: _0x146379,
        disable: _0x403ed9
      };
    },
    LazyLoad: function _0x2d853e(_0x22e38c, _0x35a539, _0x18e418) {
      var _0x232133 = _0x363a4b(_0x22e38c);
      var _0x4b3f87 = _0x232133.on;
      var _0x2f5f5a = _0x232133.off;
      var _0x11f7f5 = _0x232133.bind;
      var _0x2428a6 = _0x232133.emit;
      var _0x481fdd = _0x18e418.lazyLoad === "sequential";
      var _0x5ed14f = [_0x5d93d1, _0x52f360];
      var _0x4a293b = [];
      function _0x38142d() {
        _0x77774c(_0x4a293b);
        _0x35a539.Slides.forEach(function (_0x3a3217) {
          _0xd9ee9f(_0x3a3217.slide, _0x5b74c1).forEach(function (_0x2b0681) {
            var _0x5871aa = _0x2f628f(_0x2b0681, _0x2a10c2);
            var _0x3021c1 = _0x2f628f(_0x2b0681, _0x1c70f7);
            if (_0x5871aa !== _0x2b0681.src || _0x3021c1 !== _0x2b0681.srcset) {
              var _0x4880d7 = _0x18e418.classes.spinner;
              var _0x18de70 = _0x2b0681.parentElement;
              var _0x3bec83 = _0x51a178(_0x18de70, "." + _0x4880d7) || _0x3032d3("span", _0x4880d7, _0x18de70);
              _0x4a293b.push([_0x2b0681, _0x3a3217, _0x3bec83]);
              if (!_0x2b0681.src) {
                _0x16f028(_0x2b0681, "none");
              }
            }
          });
        });
        if (_0x481fdd) {
          _0x267829();
        } else {
          _0x2f5f5a(_0x5ed14f);
          _0x4b3f87(_0x5ed14f, _0x3f2c0f);
          _0x3f2c0f();
        }
      }
      function _0x3f2c0f() {
        if (!(_0x4a293b = _0x4a293b.filter(function (_0x25ff6a) {
          var _0x26b22d = _0x18e418.perPage * ((_0x18e418.preloadPages || 1) + 1) - 1;
          return !_0x25ff6a[1].isWithin(_0x22e38c.index, _0x26b22d) || _0x12f163(_0x25ff6a);
        })).length) {
          _0x2f5f5a(_0x5ed14f);
        }
      }
      function _0x12f163(_0x1a505c) {
        var _0x20c40a = _0x1a505c[0];
        _0x3de5e8(_0x1a505c[1].slide, _0x1d8179);
        _0x11f7f5(_0x20c40a, "load error", _0x33a7a6(_0x3e4b7a, _0x1a505c));
        _0x5a898f(_0x20c40a, "src", _0x2f628f(_0x20c40a, _0x2a10c2));
        _0x5a898f(_0x20c40a, "srcset", _0x2f628f(_0x20c40a, _0x1c70f7));
        _0x51dc8a(_0x20c40a, _0x2a10c2);
        _0x51dc8a(_0x20c40a, _0x1c70f7);
      }
      function _0x3e4b7a(_0x526a31, _0x1f4a6e) {
        var _0xc54da5 = _0x526a31[0];
        var _0x6157c8 = _0x526a31[1];
        _0x16ca5c(_0x6157c8.slide, _0x1d8179);
        if (_0x1f4a6e.type !== "error") {
          _0x449ca4(_0x526a31[2]);
          _0x16f028(_0xc54da5, "");
          _0x2428a6(_0x51e66e, _0xc54da5, _0x6157c8);
          _0x2428a6(_0x5366f8);
        }
        if (_0x481fdd) {
          _0x267829();
        }
      }
      function _0x267829() {
        if (_0x4a293b.length) {
          _0x12f163(_0x4a293b.shift());
        }
      }
      return {
        mount: function _0x62a88a() {
          if (_0x18e418.lazyLoad) {
            _0x38142d();
            _0x4b3f87(_0x4b86f0, _0x38142d);
          }
        },
        destroy: _0x33a7a6(_0x77774c, _0x4a293b),
        check: _0x3f2c0f
      };
    },
    Pagination: function _0x461e99(_0x42d473, _0x319bf2, _0x3e3c05) {
      var _0x21dcb8;
      var _0x54dab6;
      var _0x42e4f4 = _0x363a4b(_0x42d473);
      var _0x1fa50a = _0x42e4f4.on;
      var _0x527fef = _0x42e4f4.emit;
      var _0xe55449 = _0x42e4f4.bind;
      var _0x5c986a = _0x319bf2.Slides;
      var _0xbef07c = _0x319bf2.Elements;
      var _0x3c6e5b = _0x319bf2.Controller;
      var _0x60e04b = _0x3c6e5b.hasFocus;
      var _0x3d17e1 = _0x3c6e5b.getIndex;
      var _0x2a7b6e = _0x3c6e5b.go;
      var _0x6c1ee = _0x319bf2.Direction.resolve;
      var _0xb6fcec = _0xbef07c.pagination;
      var _0x1f57af = [];
      function _0x13c39b() {
        _0x1903dd();
        _0x1fa50a([_0x4453ff, _0x4b86f0, "ei"], _0x13c39b);
        var _0x2315ba = _0x3e3c05.pagination;
        if (_0xb6fcec) {
          _0x16f028(_0xb6fcec, _0x2315ba ? "" : "none");
        }
        if (_0x2315ba) {
          _0x1fa50a([_0x159994, _0x4103b9, _0x52f360], _0x1c3bd9);
          (function _0x8c4839() {
            var _0x207d90 = _0x42d473.length;
            var _0x3298c0 = _0x3e3c05.classes;
            var _0x39d8c5 = _0x3e3c05.i18n;
            var _0x599f23 = _0x3e3c05.perPage;
            var _0x234ca6 = _0x60e04b() ? _0x3c6e5b.getEnd() + 1 : _0x3058fc(_0x207d90 / _0x599f23);
            _0x21dcb8 = _0xb6fcec || _0x3032d3("ul", _0x3298c0.pagination, _0xbef07c.track.parentElement);
            _0x3de5e8(_0x21dcb8, _0x54dab6 = _0x13a5af + "--" + _0x9ac6a9());
            _0x5a898f(_0x21dcb8, _0x295bdc, "tablist");
            _0x5a898f(_0x21dcb8, _0x2e9e96, _0x39d8c5.select);
            _0x5a898f(_0x21dcb8, _0x1c7b96, _0x9ac6a9() === "ttb" ? "vertical" : "");
            for (var _0x502ea7 = 0; _0x502ea7 < _0x234ca6; _0x502ea7++) {
              var _0x4f0654 = _0x3032d3("li", null, _0x21dcb8);
              var _0x23b80f = {
                class: _0x3298c0.page,
                type: "button"
              };
              var _0x203806 = _0x23b80f;
              var _0x10fbe2 = _0x3032d3("button", _0x203806, _0x4f0654);
              var _0x1b25f2 = _0x5c986a.getIn(_0x502ea7).map(function (_0x45b3d2) {
                return _0x45b3d2.slide.id;
              });
              var _0x26618d = !_0x60e04b() && _0x599f23 > 1 ? _0x39d8c5.pageX : _0x39d8c5.slideX;
              _0xe55449(_0x10fbe2, "click", _0x33a7a6(_0x21d74d, _0x502ea7));
              if (_0x3e3c05.paginationKeyboard) {
                _0xe55449(_0x10fbe2, "keydown", _0x33a7a6(_0x3829a9, _0x502ea7));
              }
              _0x5a898f(_0x4f0654, _0x295bdc, "presentation");
              _0x5a898f(_0x10fbe2, _0x295bdc, "tab");
              _0x5a898f(_0x10fbe2, _0x5b1006, _0x1b25f2.join(" "));
              _0x5a898f(_0x10fbe2, _0x2e9e96, _0x19b83e(_0x26618d, _0x502ea7 + 1));
              _0x5a898f(_0x10fbe2, _0x4f62aa, -1);
              var _0x3a71b = {
                li: _0x4f0654,
                button: _0x10fbe2,
                page: _0x502ea7
              };
              var _0x12d655 = _0x3a71b;
              _0x1f57af.push(_0x12d655);
            }
          })();
          _0x1c3bd9();
          var _0x3db479 = {
            list: _0x21dcb8,
            items: _0x1f57af
          };
          var _0x5f570f = _0x3db479;
          _0x527fef("pagination:mounted", _0x5f570f, _0x2c2db2(_0x42d473.index));
        }
      }
      function _0x1903dd() {
        if (_0x21dcb8) {
          _0x449ca4(_0xb6fcec ? _0xa1a96e(_0x21dcb8.children) : _0x21dcb8);
          _0x16ca5c(_0x21dcb8, _0x54dab6);
          _0x77774c(_0x1f57af);
          _0x21dcb8 = null;
        }
        _0x42e4f4.destroy();
      }
      function _0x21d74d(_0x564417) {
        _0x2a7b6e(">" + _0x564417, true);
      }
      function _0x3829a9(_0x1693ef, _0x47cf31) {
        var _0x5c151a = _0x1f57af.length;
        var _0x4495c8 = _0x57516f(_0x47cf31);
        var _0xd028a7 = _0x9ac6a9();
        var _0x233616 = -1;
        if (_0x4495c8 === _0x6c1ee(_0x332a28, false, _0xd028a7)) {
          _0x233616 = ++_0x1693ef % _0x5c151a;
        } else if (_0x4495c8 === _0x6c1ee(_0x1834a8, false, _0xd028a7)) {
          _0x233616 = (--_0x1693ef + _0x5c151a) % _0x5c151a;
        } else if (_0x4495c8 === "Home") {
          _0x233616 = 0;
        } else if (_0x4495c8 === "End") {
          _0x233616 = _0x5c151a - 1;
        }
        var _0x5d0eb8 = _0x1f57af[_0x233616];
        if (_0x5d0eb8) {
          _0x3c95ae(_0x5d0eb8.button);
          _0x2a7b6e(">" + _0x233616);
          _0x20290d(_0x47cf31, true);
        }
      }
      function _0x9ac6a9() {
        return _0x3e3c05.paginationDirection || _0x3e3c05.direction;
      }
      function _0x2c2db2(_0x460170) {
        return _0x1f57af[_0x3c6e5b.toPage(_0x460170)];
      }
      function _0x1c3bd9() {
        var _0x1b4dfe = _0x2c2db2(_0x3d17e1(true));
        var _0x15bbee = _0x2c2db2(_0x3d17e1());
        if (_0x1b4dfe) {
          var _0x4b4030 = _0x1b4dfe.button;
          _0x16ca5c(_0x4b4030, _0x2d5a91);
          _0x51dc8a(_0x4b4030, _0x3b5da8);
          _0x5a898f(_0x4b4030, _0x4f62aa, -1);
        }
        if (_0x15bbee) {
          var _0xa3c6ff = _0x15bbee.button;
          _0x3de5e8(_0xa3c6ff, _0x2d5a91);
          _0x5a898f(_0xa3c6ff, _0x3b5da8, true);
          _0x5a898f(_0xa3c6ff, _0x4f62aa, "");
        }
        var _0xafb504 = {
          list: _0x21dcb8,
          items: _0x1f57af
        };
        var _0x9fb160 = _0xafb504;
        _0x527fef("pagination:updated", _0x9fb160, _0x1b4dfe, _0x15bbee);
      }
      var _0x787e9b = {
        items: _0x1f57af,
        mount: _0x13c39b,
        destroy: _0x1903dd,
        getAt: _0x2c2db2,
        update: _0x1c3bd9
      };
      var _0x2e1892 = _0x787e9b;
      return _0x2e1892;
    },
    Sync: function _0x26e825(_0xf27ffe, _0x54576e, _0x1fa3ff) {
      var _0x4f1149 = _0x1fa3ff.isNavigation;
      var _0x8e8100 = _0x1fa3ff.slideFocus;
      var _0x4a8aa7 = [];
      function _0x4450a1() {
        var _0x527971;
        var _0x3e177f;
        _0xf27ffe.splides.forEach(function (_0x1d3e00) {
          if (!_0x1d3e00.isParent) {
            _0x31b671(_0xf27ffe, _0x1d3e00.splide);
            _0x31b671(_0x1d3e00.splide, _0xf27ffe);
          }
        });
        if (_0x4f1149) {
          _0x527971 = _0x363a4b(_0xf27ffe);
          _0x3e177f = _0x527971.on;
          _0x3e177f(_0x2e574f, _0x3a1e12);
          _0x3e177f("sk", _0x27e40f);
          _0x3e177f([_0x4ceba9, _0x4453ff], _0x3e01a9);
          _0x4a8aa7.push(_0x527971);
          _0x527971.emit(_0x3a198f, _0xf27ffe.splides);
        }
      }
      function _0x1c8ab0() {
        _0x4a8aa7.forEach(function (_0x404735) {
          _0x404735.destroy();
        });
        _0x77774c(_0x4a8aa7);
      }
      function _0x31b671(_0x34175a, _0x24ded9) {
        var _0x5d8181 = _0x363a4b(_0x34175a);
        _0x5d8181.on(_0x159994, function (_0x54e8, _0x5a9443, _0x372fd9) {
          _0x24ded9.go(_0x24ded9.is(_0xec8ced) ? _0x372fd9 : _0x54e8);
        });
        _0x4a8aa7.push(_0x5d8181);
      }
      function _0x3e01a9() {
        _0x5a898f(_0x54576e.Elements.list, _0x1c7b96, _0x1fa3ff.direction === "ttb" ? "vertical" : "");
      }
      function _0x3a1e12(_0x4bb94c) {
        _0xf27ffe.go(_0x4bb94c.index);
      }
      function _0x27e40f(_0x44ed2b, _0x11824a) {
        if (_0x55a8ba(_0xe13538, _0x57516f(_0x11824a))) {
          _0x3a1e12(_0x44ed2b);
          _0x20290d(_0x11824a);
        }
      }
      return {
        setup: _0x33a7a6(_0x54576e.Media.set, {
          slideFocus: _0x4ea64a(_0x8e8100) ? _0x4f1149 : _0x8e8100
        }, true),
        mount: _0x4450a1,
        destroy: _0x1c8ab0,
        remount: function _0x23a065() {
          _0x1c8ab0();
          _0x4450a1();
        }
      };
    },
    Wheel: function _0x3fad78(_0x3ea790, _0x12f929, _0x5ad8a0) {
      var _0x150d76 = _0x363a4b(_0x3ea790).bind;
      var _0x52135c = 0;
      function _0x76b6ed(_0x25a44f) {
        if (_0x25a44f.cancelable) {
          var _0x489b7e;
          var _0x225d0d = _0x25a44f.deltaY;
          var _0x5b65fc = _0x225d0d < 0;
          var _0x93fcac = _0x9a9c01(_0x25a44f);
          var _0x1c4db9 = _0x5ad8a0.wheelMinThreshold || 0;
          var _0x7db278 = _0x5ad8a0.wheelSleep || 0;
          if (_0x568cd5(_0x225d0d) > _0x1c4db9 && _0x93fcac - _0x52135c > _0x7db278) {
            _0x3ea790.go(_0x5b65fc ? "<" : ">");
            _0x52135c = _0x93fcac;
          }
          _0x489b7e = _0x5b65fc;
          if (!_0x5ad8a0.releaseWheel || _0x3ea790.state.is(4) || _0x12f929.Controller.getAdjacent(_0x489b7e) !== -1) {
            _0x20290d(_0x25a44f);
          }
        }
      }
      return {
        mount: function _0x5e081e() {
          if (_0x5ad8a0.wheel) {
            _0x150d76(_0x12f929.Elements.track, "wheel", _0x76b6ed, _0x13f840);
          }
        }
      };
    },
    Live: function _0x3496c3(_0x4e46f5, _0x5aa54f, _0x3c2969) {
      var _0x285c79 = _0x363a4b(_0x4e46f5).on;
      var _0x11b3e4 = _0x5aa54f.Elements.track;
      var _0x52e8a0 = _0x3c2969.live && !_0x3c2969.isNavigation;
      var _0x4ccbc2 = _0x3032d3("span", _0x2bb7ae);
      var _0x34d231 = _0x5d9744(90, _0x33a7a6(_0x2cf143, false));
      function _0x2cf143(_0x4a1c74) {
        _0x5a898f(_0x11b3e4, _0x4826b6, _0x4a1c74);
        if (_0x4a1c74) {
          _0x254497(_0x11b3e4, _0x4ccbc2);
          _0x34d231.start();
        } else {
          _0x449ca4(_0x4ccbc2);
          _0x34d231.cancel();
        }
      }
      function _0x2a742b(_0x4e1334) {
        if (_0x52e8a0) {
          _0x5a898f(_0x11b3e4, _0x873bb2, _0x4e1334 ? "off" : "polite");
        }
      }
      return {
        mount: function _0x2971ef() {
          if (_0x52e8a0) {
            _0x2a742b(!_0x5aa54f.Autoplay.isPaused());
            _0x5a898f(_0x11b3e4, _0x3db62f, true);
            _0x4ccbc2.textContent = "…";
            _0x285c79(_0x396e53, _0x33a7a6(_0x2a742b, true));
            _0x285c79(_0x25fa6d, _0x33a7a6(_0x2a742b, false));
            _0x285c79([_0x5d93d1, _0x52f360], _0x33a7a6(_0x2cf143, true));
          }
        },
        disable: _0x2a742b,
        destroy: function _0x4e3e4f() {
          _0x51dc8a(_0x11b3e4, [_0x873bb2, _0x3db62f, _0x4826b6]);
          _0x449ca4(_0x4ccbc2);
        }
      };
    }
  });
  var _0x444782 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: {},
    i18n: {},
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
      autoplay: "pause"
    }
  };
  _0x444782.classes.slide = _0x27ee42;
  _0x444782.classes.clone = _0x14badb;
  _0x444782.classes.arrows = _0x521429;
  _0x444782.classes.arrow = _0x4edeb0;
  _0x444782.classes.prev = _0x357623;
  _0x444782.classes.next = _0x23c09e;
  _0x444782.classes.pagination = _0x13a5af;
  _0x444782.classes.page = _0x48d50b;
  _0x444782.classes.spinner = _0x562971 + "spinner";
  _0x444782.i18n.prev = "Previous slide";
  _0x444782.i18n.next = "Next slide";
  _0x444782.i18n.first = "Go to first slide";
  _0x444782.i18n.last = "Go to last slide";
  _0x444782.i18n.slideX = "Go to slide %s";
  _0x444782.i18n.pageX = "Go to page %s";
  _0x444782.i18n.play = "Start autoplay";
  _0x444782.i18n.pause = "Pause autoplay";
  _0x444782.i18n.carousel = "carousel";
  _0x444782.i18n.slide = "slide";
  _0x444782.i18n.select = "Select a slide to show";
  _0x444782.i18n.slideLabel = "%s of %s";
  var _0x2ca4d9 = _0x444782;
  function _0x250677(_0x3565df, _0x489a95, _0x2aaf58) {
    var _0x1462f3 = _0x489a95.Slides;
    function _0x16939e() {
      _0x1462f3.forEach(function (_0x38ebdd) {
        _0x38ebdd.style("transform", "translateX(-" + _0x38ebdd.index * 100 + "%)");
      });
    }
    return {
      mount: function _0x1fcaa2() {
        _0x363a4b(_0x3565df).on([_0x4ceba9, _0x4b86f0], _0x16939e);
      },
      start: function _0x35bcd0(_0x208a4c, _0x132735) {
        _0x1462f3.style("transition", "opacity " + _0x2aaf58.speed + "ms " + _0x2aaf58.easing);
        _0x8b7901(_0x132735);
      },
      cancel: _0x2ef7ef
    };
  }
  function _0x235015(_0x552893, _0x29ca10, _0x516370) {
    var _0x4ff394;
    var _0x20c1dc = _0x29ca10.Move;
    var _0x30b7c9 = _0x29ca10.Controller;
    var _0x81638c = _0x29ca10.Scroll;
    var _0x2cccec = _0x29ca10.Elements.list;
    var _0x23efdd = _0x33a7a6(_0x2420ba, _0x2cccec, "transition");
    function _0xcbe1f5() {
      _0x23efdd("");
      _0x81638c.cancel();
    }
    return {
      mount: function _0x5c66b3() {
        _0x363a4b(_0x552893).bind(_0x2cccec, "transitionend", function (_0x5910f1) {
          if (_0x5910f1.target === _0x2cccec && _0x4ff394) {
            _0xcbe1f5();
            _0x4ff394();
          }
        });
      },
      start: function _0x4583e9(_0x46e1ad, _0x2af7b4) {
        var _0x3de5b5 = _0x20c1dc.toPosition(_0x46e1ad, true);
        var _0x58002c = _0x20c1dc.getPosition();
        var _0xd10975 = function _0x3c0327(_0x447572) {
          var _0x52aab3 = _0x516370.rewindSpeed;
          if (_0x552893.is(_0x55a895) && _0x52aab3) {
            var _0x2e7315 = _0x30b7c9.getIndex(true);
            var _0x2bde0b = _0x30b7c9.getEnd();
            if (_0x2e7315 === 0 && _0x447572 >= _0x2bde0b || _0x2e7315 >= _0x2bde0b && _0x447572 === 0) {
              return _0x52aab3;
            }
          }
          return _0x516370.speed;
        }(_0x46e1ad);
        if (_0x568cd5(_0x3de5b5 - _0x58002c) >= 1 && _0xd10975 >= 1) {
          if (_0x516370.useScroll) {
            _0x81638c.scroll(_0x3de5b5, _0xd10975, false, _0x2af7b4);
          } else {
            _0x23efdd("transform " + _0xd10975 + "ms " + _0x516370.easing);
            _0x20c1dc.translate(_0x3de5b5, true);
            _0x4ff394 = _0x2af7b4;
          }
        } else {
          _0x20c1dc.jump(_0x46e1ad);
          _0x2af7b4();
        }
      },
      cancel: _0xcbe1f5
    };
  }
  var _0x6e1757 = function () {
    function _0x1b266(_0x172b17, _0xe03533) {
      this.event = _0x363a4b();
      this.Components = {};
      this.state = function _0x53dc32(_0x1acded) {
        var _0x344b84 = 1;
        function _0xddedf8(_0x57b649) {
          _0x344b84 = _0x57b649;
        }
        return {
          set: _0xddedf8,
          is: function _0x33137a(_0x57765d) {
            return _0x55a8ba(_0x1b2766(_0x57765d), _0x344b84);
          }
        };
      }(1);
      this.splides = [];
      this._o = {};
      this._E = {};
      var _0x1159ab = _0x139f33(_0x172b17) ? _0x601eba(document, _0x172b17) : _0x172b17;
      _0x4542b1(_0x1159ab, _0x1159ab + " is invalid.");
      this.root = _0x1159ab;
      _0xe03533 = _0x3cff8b({
        label: _0x2f628f(_0x1159ab, _0x2e9e96) || "",
        labelledby: _0x2f628f(_0x1159ab, _0x3d6492) || ""
      }, _0x2ca4d9, _0x1b266.defaults, _0xe03533 || {});
      try {
        _0x3cff8b(_0xe03533, JSON.parse(_0x2f628f(_0x1159ab, _0x59344c)));
      } catch (_0x1ba751) {
        _0x4542b1(false, "Invalid JSON");
      }
      this._o = Object.create(_0x3cff8b({}, _0xe03533));
    }
    var _0x57628e = _0x1b266.prototype;
    _0x57628e.mount = function _0x5ca624(_0x39d7f1, _0xca5704) {
      var _0x5c7626 = this;
      var _0x3f5b73 = this.state;
      var _0x28808f = this.Components;
      _0x4542b1(_0x3f5b73.is([1, 7]), "Already mounted!");
      _0x3f5b73.set(1);
      this._C = _0x28808f;
      this._T = _0xca5704 || this._T || (this.is(_0x4f05ae) ? _0x250677 : _0x235015);
      this._E = _0x39d7f1 || this._E;
      var _0x3d8868 = _0x50c18a({}, _0x499b9a, this._E, {
        Transition: this._T
      });
      _0x4f2984(_0x3d8868, function (_0x29222a, _0x54a53f) {
        var _0x5ef7db = _0x29222a(_0x5c7626, _0x28808f, _0x5c7626._o);
        _0x28808f[_0x54a53f] = _0x5ef7db;
        if (_0x5ef7db.setup) {
          _0x5ef7db.setup();
        }
      });
      _0x4f2984(_0x28808f, function (_0x4a5c0c) {
        if (_0x4a5c0c.mount) {
          _0x4a5c0c.mount();
        }
      });
      this.emit(_0x4ceba9);
      _0x3de5e8(this.root, "is-initialized");
      _0x3f5b73.set(3);
      this.emit(_0x315e58);
      return this;
    };
    _0x57628e.sync = function _0x44a91a(_0x27e6dd) {
      var _0xda6ba6 = {
        splide: _0x27e6dd
      };
      var _0x30069b = _0xda6ba6;
      this.splides.push(_0x30069b);
      var _0x1d84a2 = {
        splide: this,
        isParent: true
      };
      var _0x3ba9be = _0x1d84a2;
      _0x27e6dd.splides.push(_0x3ba9be);
      if (this.state.is(3)) {
        this._C.Sync.remount();
        _0x27e6dd.Components.Sync.remount();
      }
      return this;
    };
    _0x57628e.go = function _0xdb01c5(_0x4de7f6) {
      this._C.Controller.go(_0x4de7f6);
      return this;
    };
    _0x57628e.on = function _0x11869b(_0x2a56b4, _0x44f306) {
      this.event.on(_0x2a56b4, _0x44f306);
      return this;
    };
    _0x57628e.off = function _0x1adda0(_0x1cb8d9) {
      this.event.off(_0x1cb8d9);
      return this;
    };
    _0x57628e.emit = function _0x2df8a9(_0xc0b88a) {
      var _0x24522d;
      (_0x24522d = this.event).emit.apply(_0x24522d, [_0xc0b88a].concat(_0xa1a96e(arguments, 1)));
      return this;
    };
    _0x57628e.add = function _0x5384ac(_0x2ea1bb, _0x47573f) {
      this._C.Slides.add(_0x2ea1bb, _0x47573f);
      return this;
    };
    _0x57628e.remove = function _0x4ea818(_0x333c51) {
      this._C.Slides.remove(_0x333c51);
      return this;
    };
    _0x57628e.is = function _0x161eb3(_0x4c9f1e) {
      return this._o.type === _0x4c9f1e;
    };
    _0x57628e.refresh = function _0x1265f4() {
      this.emit(_0x4b86f0);
      return this;
    };
    _0x57628e.destroy = function _0x594b63(_0x1ee39b = true) {
      var _0x38f24c = this.event;
      var _0x3bacdc = this.state;
      if (_0x3bacdc.is(1)) {
        _0x363a4b(this).on(_0x315e58, this.destroy.bind(this, _0x1ee39b));
      } else {
        _0x4f2984(this._C, function (_0x521934) {
          if (_0x521934.destroy) {
            _0x521934.destroy(_0x1ee39b);
          }
        }, true);
        _0x38f24c.emit(_0xb7d7a4);
        _0x38f24c.destroy();
        if (_0x1ee39b) {
          _0x77774c(this.splides);
        }
        _0x3bacdc.set(7);
      }
      return this;
    };
    _createClass(_0x1b266, [{
      key: "options",
      get: function _0x5979c0() {
        return this._o;
      },
      set: function _0x4fbf3f(_0x536d62) {
        this._C.Media.set(_0x536d62, true, true);
      }
    }, {
      key: "length",
      get: function _0x54ebf3() {
        return this._C.Slides.getLength(true);
      }
    }, {
      key: "index",
      get: function _0x14f772() {
        return this._C.Controller.getIndex();
      }
    }]);
    return _0x1b266;
  }();
  _0x6e1757.defaults = {};
  _0x6e1757.STATES = {
    CREATED: 1,
    MOUNTED: 2,
    IDLE: 3,
    MOVING: 4,
    SCROLLING: 5,
    DRAGGING: 6,
    DESTROYED: 7
  };
  return _0x6e1757;
});
class SplideComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderContainer = this.querySelector(".splide");
    document.addEventListener("shopify:section:load", _0x147d79 => {
      this.initSlider();
    });
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    this.type = this.dataset.type || "slide";
    this.typeMobile = this.dataset.typeMobile || this.type;
    this.direction = this.dataset.direction || defaultDirection;
    this.rewind = this.type === "fade";
    this.autoplay = this.dataset.autoplay === "true";
    this.autoplaySpeed = this.dataset.autoplaySpeed && !isNaN(parseInt(this.dataset.autoplaySpeed)) ? parseInt(this.dataset.autoplaySpeed) * 1000 : 5000;
    this.drag = this.dataset.drag !== "false" && (this.dataset.drag !== "free" || "free");
    this.focus = this.dataset.focus || 0;
    this.trimSpace = this.dataset.trimSpace !== "false";
    this.arrows = this.dataset.arrows !== "false";
    this.arrowsColor = this.dataset.arrowsColor ? " color-" + this.dataset.arrowsColor : "";
    this.pagination = this.dataset.pagination !== "false";
    this.omitEnd = this.dataset.omitEnd !== "false";
    this.dotsColor = this.dataset.dotsColor ? " color-" + this.dataset.dotsColor + " dots-custom-color" : "";
    this.slidesDesktop = this.dataset.slidesDesktop && !isNaN(parseInt(this.dataset.slidesDesktop)) ? parseInt(this.dataset.slidesDesktop) : 3;
    this.autoWidth = this.dataset.autoWidth === "true";
    this.slidesMobile = this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile)) ? parseInt(this.dataset.slidesMobile) : 1;
    this.perMoveDesktop = this.dataset.perMoveDesktop && !isNaN(parseInt(this.dataset.perMoveDesktop)) ? parseInt(this.dataset.perMoveDesktop) : 1;
    this.perMoveMobile = this.dataset.perMoveMobile && !isNaN(parseInt(this.dataset.perMoveMobile)) ? parseInt(this.dataset.perMoveMobile) : 1;
    this.gapDesktop = this.dataset.gapDesktop ? parseInt(this.dataset.gapDesktop) : 30;
    this.gapMobile = this.dataset.gapMobile ? parseInt(this.dataset.gapMobile) : 15;
    this.paddingCalcDesktop = this.dataset.paddingCalcDesktop === "true";
    this.rightPaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0;
    this.leftPaddingDesktop = this.dataset.paddingCalcDesktop ? 0 : this.rightPaddingDesktop;
    this.paddingCalcMobile = this.dataset.paddingCalcMobile === "true";
    this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0;
    this.leftPaddingMobile = this.paddingCalcMobile ? 0 : this.rightPaddingMobile;
    this.destroyDesktop = this.dataset.destroyDesktop === "true";
    this.destroyMobile = this.dataset.destroyMobile === "true";
    this.config = {
      type: this.type,
      direction: this.direction,
      rewind: this.rewind,
      autoplay: this.autoplay,
      interval: this.autoplaySpeed,
      drag: this.drag,
      focus: this.focus,
      trimSpace: this.trimSpace,
      arrows: this.arrows,
      pagination: this.pagination,
      omitEnd: this.omitEnd,
      perPage: this.slidesDesktop,
      perMove: this.perMoveDesktop,
      autoWidth: this.autoWidth,
      gap: this.gapDesktop,
      paddingCalc: this.paddingCalcDesktop,
      padding: {
        left: this.leftPaddingDesktop,
        right: this.rightPaddingDesktop
      },
      destroy: this.destroyDesktop,
      classes: {
        arrow: "splide__arrow" + this.arrowsColor,
        page: "splide__pagination__page" + this.dotsColor
      },
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
      breakpoints: {
        749: {
          omitEnd: this.omitEnd,
          type: this.typeMobile,
          perPage: this.slidesMobile,
          perMove: this.perMoveMobile,
          gap: this.gapMobile,
          paddingCalc: this.paddingCalcMobile,
          padding: {
            left: this.leftPaddingMobile,
            right: this.rightPaddingMobile
          },
          destroy: this.destroyMobile
        }
      }
    };
    let _0x2a3105 = new Splide(this.sliderContainer, this.config);
    _0x2a3105.on("mounted", () => {
      let _0x5238f0 = _0x2a3105.index;
      let _0x342ad2 = _0x2a3105.Components.Elements.slides[_0x5238f0];
      if (_0x342ad2) {
        let _0x265178 = _0x342ad2.querySelector("img");
        if (_0x265178) {
          if (_0x265178.complete) {
            _0x342ad2.classList.add("is-instant-active");
            this.setActiveSlideHeight(_0x342ad2);
          } else {
            _0x265178.addEventListener("load", () => {
              _0x342ad2.classList.add("is-instant-active");
              this.setActiveSlideHeight(_0x342ad2);
            });
          }
        } else {
          _0x342ad2.classList.add("is-instant-active");
          this.setActiveSlideHeight(_0x342ad2);
        }
      }
      let _0x521152 = debounce(() => {
        var _0x2dcef4 = _0x2a3105.Components.Elements.slides[_0x2a3105.index];
        this.setActiveSlideHeight(_0x2dcef4);
      }, 200);
      window.addEventListener("resize", _0x521152);
    });
    _0x2a3105.on("move", _0x5eb24b => {
      let _0x395c7f = _0x2a3105.index;
      let _0x10b670 = _0x2a3105.Components.Elements.slides;
      if (_0x10b670) {
        let _0x530ed8 = _0x10b670[_0x395c7f];
        if (_0x530ed8) {
          _0x10b670.forEach(_0x95f1cb => _0x95f1cb.classList.remove("is-instant-active"));
          _0x530ed8.classList.add("is-instant-active");
          this.setActiveSlideHeight(_0x530ed8);
        }
      }
    });
    if (this.dataset.pauseVideos === "true") {
      _0x2a3105.on("hidden", _0x9ac86 => {
        let _0x5f35bc = _0x9ac86.slide.querySelector("internal-video");
        if (_0x5f35bc) {
          let _0xb93726 = _0x5f35bc.dataset.actionOnInactive;
          if (_0xb93726 === "pause") {
            _0x5f35bc.video.pause();
            _0x5f35bc.classList.remove("internal-video--playing");
          } else if (_0xb93726 === "mute") {
            _0x5f35bc.video.muted = true;
            _0x5f35bc.classList.add("internal-video--muted");
          }
        }
      });
    }
    _0x2a3105.mount();
  }
  setActiveSlideHeight(_0x45d411) {
    if (_0x45d411) {
      let _0x41024f = _0x45d411.offsetHeight;
      this.style.setProperty("--active-slide-height", _0x41024f + "px");
    }
  }
}
customElements.define("splide-component", SplideComponent);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onToggle() {
    this.animations ||= this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach(_0x903561 => _0x903561.play());
    } else {
      this.animations.forEach(_0x521de8 => _0x521de8.cancel());
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }
  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
      if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") === "") {
        document.documentElement.style.setProperty("--header-bottom-position-desktop", Math.floor(this.header.getBoundingClientRect().bottom) + "px");
      }
    }
  }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.detailsContainer.addEventListener("keyup", _0x32ec8a => _0x32ec8a.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector("button[type=\"button\"]").addEventListener("click", this.close.bind(this));
    this.summaryToggle.setAttribute("role", "button");
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(_0x13a905) {
    _0x13a905.preventDefault();
    if (_0x13a905.target.closest("details").hasAttribute("open")) {
      this.close();
    } else {
      this.open(_0x13a905);
    }
  }
  onBodyClick(_0x568a0f) {
    if (!this.contains(_0x568a0f.target) || _0x568a0f.target.classList.contains("modal-overlay")) {
      this.close(false);
    }
  }
  open(_0xf5f42e) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    _0xf5f42e.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    if (typeof trapFocus == "function") {
      trapFocus(this.detailsContainer.querySelector("[tabindex=\"-1\"]"), this.detailsContainer.querySelector("input:not([type=\"hidden\"])"));
    }
  }
  close(_0x3ec766 = true) {
    if (typeof removeTrapFocus == "function") {
      removeTrapFocus(_0x3ec766 ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);
let hotspotButtons = [];
function registerHotspotButton(_0x44242b) {
  hotspotButtons.push(_0x44242b);
}
function unregisterHotspotButton(_0x1e763b) {
  let _0x183a33 = hotspotButtons.indexOf(_0x1e763b);
  if (_0x183a33 !== -1) {
    hotspotButtons.splice(_0x183a33, 1);
  }
}
document.addEventListener("mousedown", function (_0xf6f981) {
  for (let _0x314c4d of hotspotButtons) {
    if (_0x314c4d.dataset.open === "true" && !_0x314c4d.contains(_0xf6f981.target)) {
      _0x314c4d.closeModal();
    }
  }
});
class HotspotButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".hotspot-btn");
    this.content = this.querySelector(".hotspot__content");
    this.type = this.dataset.type;
    this.openEvent = this.dataset.openEvent;
    this.header = document.querySelector(".section-header");
    this.stickyHeader = document.querySelector("sticky-header");
    this.mobileOverlay = this.querySelector(".hotspot-overlay");
    this.button.addEventListener("click", this.toggleModal.bind(this));
    if (this.openEvent === "hover" && window.matchMedia("(hover: hover)").matches && window.matchMedia("(pointer: fine)").matches) {
      this.button.addEventListener("mouseover", this.openModal.bind(this));
      this.button.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this));
      this.content.addEventListener("mouseover", this.stopCheckingMouseLeave.bind(this));
      this.content.addEventListener("mouseout", this.startCheckingMouseLeave.bind(this));
    }
    if (this.mobileOverlay) {
      this.mobileOverlay.addEventListener("click", this.closeModal.bind(this));
    }
  }
  startCheckingMouseLeave() {
    this.checkingMouseLeave = true;
    setTimeout(() => {
      if (this.checkingMouseLeave) {
        this.closeModal();
      }
    }, 200);
  }
  stopCheckingMouseLeave() {
    this.checkingMouseLeave = false;
  }
  toggleModal() {
    if (this.dataset.open != "true") {
      this.openModal();
    }
  }
  openModal() {
    let _0x4ebcde = this.header.clientHeight;
    if (this.header.classList.contains("shopify-section-header-hidden") || !this.stickyHeader) {
      _0x4ebcde = 0;
    }
    if (this.content.getBoundingClientRect().top - _0x4ebcde < 0) {
      this.dataset.direction = "bottom";
    }
    this.dataset.open = "true";
  }
  closeModal() {
    this.dataset.open = "false";
    setTimeout(() => {
      this.dataset.direction = "";
    }, 100);
  }
  connectedCallback() {
    registerHotspotButton(this);
  }
  disconnectedCallback() {
    unregisterHotspotButton(this);
  }
}
customElements.define("hotspot-button", HotspotButton);
class ParallaxHero extends HTMLElement {
  constructor() {
    super();
    this.overlays = this.querySelectorAll(".parallax-hero__layer");
    this.animateOnEnter = this.dataset.animationStart === "bottom";
    this.handleScroll();
    window.addEventListener("scroll", () => requestAnimationFrame(this.handleScroll.bind(this)));
  }
  handleScroll(_0x1a4b24) {
    var {
      top: _0x3eec36,
      left: _0x1ac378,
      height: _0xa091b1
    } = this.getBoundingClientRect();
    let _0x416499 = window.innerHeight;
    let _0x3c7a38;
    if (this.animateOnEnter) {
      if (_0x3eec36 > _0x416499 || _0x3eec36 + _0xa091b1 < 0) {
        return;
      }
      _0x3c7a38 = Math.min((_0x416499 - _0x3eec36) / (_0x416499 + _0xa091b1), 1);
    } else {
      if (_0x3eec36 > _0x416499 || _0x3eec36 + _0xa091b1 < 0) {
        return;
      }
      let _0x5b81a4 = _0x3eec36 >= 0 ? 0 : -_0x3eec36;
      if (_0x5b81a4 > _0xa091b1) {
        return;
      }
      _0x3c7a38 = Math.min(_0x5b81a4 / _0xa091b1, 1);
    }
    this.overlays.forEach(_0x586029 => {
      let _0x37f2c6 = _0x3eec36 * (parseInt(_0x586029.dataset.scrollY) / 100);
      let _0x3826ce = parseInt(_0x586029.dataset.scrollX) * _0x3c7a38;
      let _0x478fde = 100 + (parseInt(_0x586029.dataset.zoom) - 100) * _0x3c7a38;
      let _0x56733b = parseInt(_0x586029.dataset.rotation) * 3.6 * _0x3c7a38;
      _0x586029.style.transform = "translateY(" + _0x37f2c6 + "px) translateX(" + _0x3826ce + "%) scale(" + _0x478fde / 100 + ") rotate(" + _0x56733b + "deg)";
    });
  }
}
customElements.define("parallax-hero", ParallaxHero);
class ContentTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".content-tab-button");
    this.tabs = this.querySelectorAll(".content-tab");
    this.tabsContainer = this.querySelector(".content-tabs__tabs");
    this.activeButton = this.querySelector(".content-tab-button--active");
    this.activeTab = this.querySelector(".content-tab--active");
    this.isMovingAnimation = this.dataset.animation === "moving";
    if (this.isMovingAnimation) {
      this.activeBg = this.querySelector(".content-tab-buttom__active-bg");
      this.handleActiveBg();
      this.activeBg.style.transitionDuration = "0.4s";
    }
    this.setHeight();
    this.buttons.forEach(_0x37df34 => {
      _0x37df34.addEventListener("click", this.handleClick.bind(this));
    });
    window.addEventListener("resize", () => {
      this.setHeight();
      if (this.isMovingAnimation) {
        this.handleActiveBg();
      }
    });
  }
  handleClick(_0x1baa82) {
    this.activeButton = _0x1baa82.currentTarget;
    this.buttons.forEach(_0x2b4b45 => {
      _0x2b4b45.classList.remove("content-tab-button--active");
    });
    this.activeButton.classList.add("content-tab-button--active");
    this.tabs.forEach(_0xc78b93 => {
      _0xc78b93.classList.remove("content-tab--active");
      if (_0xc78b93.dataset.index === this.activeButton.dataset.index) {
        this.activeTab = _0xc78b93;
      }
    });
    this.activeTab.classList.add("content-tab--active");
    this.setHeight();
    if (this.isMovingAnimation) {
      this.handleActiveBg();
    }
  }
  setHeight() {
    if (this.activeTab) {
      this.tabsContainer.style.height = this.activeTab.clientHeight + "px";
    }
  }
  handleActiveBg() {
    this.activeBg.style.width = this.activeButton.getBoundingClientRect().width + "px";
    this.activeBg.style.height = this.activeButton.getBoundingClientRect().height + "px";
    this.activeBg.style.top = this.activeButton.offsetTop + "px";
    this.activeBg.style.left = this.activeButton.offsetLeft + "px";
  }
}
customElements.define("content-tabs", ContentTabs);
class InstaStories extends HTMLElement {
  constructor() {
    super();
    this.openButtons = this.querySelectorAll(".insta-story-open-btn");
    this.openButtonsOverflowContainer = this.querySelector(".insta-stories__open-buttons-container");
    this.openButtonsContainer = this.querySelector(".insta-stories__open-buttons");
    this.openBtnsPrev = this.querySelector(".insta-stories__open-btns-prev");
    this.openBtnsNext = this.querySelector(".insta-stories__open-btns-next");
    this.closeButtons = this.querySelectorAll(".insta-stories__close-button");
    this.modal = this.querySelector(".insta-stories__modal");
    this.modalOpen = false;
    this.slider = this.querySelector(".insta-stories__slider");
    this.stories = this.querySelectorAll(".insta-story");
    this.prevBtns = this.querySelectorAll(".insta-story__prev");
    this.nextBtns = this.querySelectorAll(".insta-story__next");
    this.slideBtns = this.querySelectorAll(".insta-story__slide-btn");
    this.activeIndex = 0;
    this.activeStory = this.stories[this.activeIndex];
    this.lastIndex = parseInt(this.dataset.lastIndex);
    this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn");
    this.isPaused = false;
    this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn");
    this.isMuted = true;
    this.initStories();
    this.initButtonsSlider();
    this.openButtons.forEach(_0x3fa63c => {
      _0x3fa63c.addEventListener("click", this.openModal.bind(this));
    });
    this.closeButtons.forEach(_0x4b104a => {
      _0x4b104a.addEventListener("click", this.closeModal.bind(this));
    });
    this.prevBtns.forEach(_0x250790 => {
      _0x250790.addEventListener("click", this.storyPrevBtnClick.bind(this));
    });
    this.nextBtns.forEach(_0x8be0b1 => {
      _0x8be0b1.addEventListener("click", this.storyNextBtnClick.bind(this));
    });
    this.slideBtns.forEach(_0x150fab => {
      _0x150fab.addEventListener("click", this.slideBtnClick.bind(this));
    });
    this.pauseResumeBtns.forEach(_0x519062 => {
      _0x519062.addEventListener("click", this.togglePauseResume.bind(this));
    });
    this.volumeBtns.forEach(_0x2490f1 => {
      _0x2490f1.addEventListener("click", this.toggleIsMuted.bind(this));
    });
    this.slider.addEventListener("touchstart", this.touchStartHandler.bind(this));
    this.slider.addEventListener("touchend", this.touchEndHandler.bind(this));
    document.addEventListener("keydown", _0x5b43c5 => {
      if (this.modalOpen) {
        switch (_0x5b43c5.key) {
          case "Escape":
            this.closeModal();
            break;
          case "ArrowLeft":
            this.storyPrevBtnClick();
            break;
          case "ArrowRight":
            this.storyNextBtnClick();
        }
      }
    });
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        this.initStories();
        this.initButtonsSlider();
      });
      document.addEventListener("shopify:section:reorder", () => {
        this.initStories();
        this.initButtonsSlider();
      });
    }
  }
  autoplay() {
    let _0x3b5f56 = this.activeStory;
    let _0x3edcab = parseInt(_0x3b5f56.dataset.activeMediaIndex);
    let _0x3e4ed7 = _0x3b5f56.querySelectorAll(".insta-story__media")[_0x3edcab];
    let _0x53c0f2 = parseInt(_0x3e4ed7.getAttribute("data-duration")) * 1000;
    this.updateProgressBars(_0x3edcab);
    this.autoplayStartTime = Date.now();
    this.autoplayTimeout = setTimeout(() => {
      this.storyNextBtnClick();
    }, _0x53c0f2);
  }
  storyPrevBtnClick() {
    let _0x25646a = this.activeStory;
    if (_0x25646a.dataset.activeMediaIndex === "0") {
      this.changeActiveStory(this.activeIndex - 1);
    } else {
      this.changeActiveMedia(parseInt(_0x25646a.dataset.activeMediaIndex) - 1);
    }
  }
  storyNextBtnClick() {
    let _0x422980 = this.activeStory;
    if (_0x422980.dataset.activeMediaIndex === _0x422980.dataset.lastMediaIndex) {
      this.changeActiveStory(this.activeIndex + 1);
    } else {
      this.changeActiveMedia(parseInt(_0x422980.dataset.activeMediaIndex) + 1);
    }
  }
  slideBtnClick(_0x146d3f) {
    let _0xad74d9 = parseInt(_0x146d3f.currentTarget.dataset.index);
    this.changeActiveStory(_0xad74d9);
  }
  changeActiveStory(_0x366fc5) {
    clearTimeout(this.autoplayTimeout);
    if (_0x366fc5 > this.lastIndex || _0x366fc5 < 0) {
      return;
    }
    let _0x988d35 = this.stories[this.activeIndex];
    let _0x1ea961 = parseInt(_0x988d35.dataset.activeMediaIndex);
    if (_0x988d35.dataset.played === "true" || _0x1ea961 > 0) {
      let _0x40f80 = _0x988d35.querySelectorAll(".insta-story__progress-item")[_0x1ea961];
      if (_0x40f80) {
        _0x40f80.classList.remove("insta-story__progress-item--active");
        if (_0x366fc5 > this.activeIndex) {
          _0x40f80.classList.add("insta-story__progress-item--completed");
        }
      }
    }
    let _0x2aa521 = _0x988d35.querySelectorAll(".insta-story__media")[_0x1ea961];
    if (_0x2aa521 && _0x2aa521.getAttribute("data-type") === "video") {
      let _0x1cbce4 = _0x2aa521.querySelector("video");
      if (_0x1cbce4) {
        _0x1cbce4.pause();
        if (!this.isPaused) {
          _0x1cbce4.currentTime = 0;
        }
      }
    }
    this.activeIndex = _0x366fc5;
    this.activeStory = this.stories[this.activeIndex];
    this.stories.forEach(_0x20829a => {
      _0x20829a.classList.remove("insta-story--active");
    });
    this.activeStory.classList.add("insta-story--active");
    this.activeStory.dataset.played = "true";
    this.slider.style.transform = "translateX(calc(var(--story-width) * " + this.activeIndex * (isRtl ? 1 : -1) + "))";
    let _0x3579ba = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
    this.changeActiveMedia(_0x3579ba);
    this.updateProgressBars(_0x3579ba);
  }
  changeActiveMedia(_0x16d6c4) {
    clearTimeout(this.autoplayTimeout);
    if (_0x16d6c4 < 0) {
      return;
    }
    let _0x57dfbe = this.activeStory;
    let _0x26914c = parseInt(_0x57dfbe.dataset.lastMediaIndex);
    if (_0x16d6c4 > _0x26914c) {
      return;
    }
    _0x57dfbe.dataset.activeMediaIndex = _0x16d6c4;
    let _0x354e16 = _0x57dfbe.querySelectorAll(".insta-story__media");
    for (let _0x119e77 = 0; _0x119e77 < _0x354e16.length; _0x119e77++) {
      if (_0x119e77 === _0x16d6c4) {
        _0x354e16[_0x119e77].style.display = "block";
        if (_0x354e16[_0x119e77].getAttribute("data-type") === "video") {
          let _0x2b55df = _0x354e16[_0x119e77].querySelector("video");
          if (_0x2b55df && !this.isPaused) {
            _0x2b55df.play();
          }
        }
        _0x57dfbe.querySelector(".insta-story__time-posted").innerHTML = _0x354e16[_0x119e77].dataset.timePosted;
      } else {
        _0x354e16[_0x119e77].style.display = "";
        if (_0x354e16[_0x119e77].getAttribute("data-type") === "video") {
          let _0x20708d = _0x354e16[_0x119e77].querySelector("video");
          if (_0x20708d) {
            _0x20708d.pause();
            if (!this.isPaused) {
              _0x20708d.currentTime = 0;
            }
          }
        }
      }
    }
    this.updateProgressBars(_0x16d6c4);
    if (!this.isPaused) {
      this.autoplay();
    }
    let _0xf44bae = _0x57dfbe.querySelectorAll(".insta-story__prev");
    let _0x1fbcbc = _0x57dfbe.querySelectorAll(".insta-story__next");
    _0xf44bae.forEach(_0x4b1b30 => {
      if (this.activeIndex === 0 && _0x16d6c4 === 0) {
        _0x4b1b30.setAttribute("disabled", "");
      } else {
        _0x4b1b30.removeAttribute("disabled");
      }
    });
    _0x1fbcbc.forEach(_0x2d7812 => {
      if (this.activeIndex === this.lastIndex && _0x16d6c4 === _0x26914c) {
        _0x2d7812.setAttribute("disabled", "");
      } else {
        _0x2d7812.removeAttribute("disabled");
      }
    });
  }
  updateProgressBars(_0x2bad32) {
    let _0x2a5f58 = this.activeStory;
    let _0x1ccade = _0x2a5f58.querySelectorAll(".insta-story__progress-item");
    _0x1ccade.forEach((_0x1a6b06, _0x43e437) => {
      _0x1a6b06.classList.remove("insta-story__progress-item--completed", "insta-story__progress-item--active");
      if (_0x43e437 < _0x2bad32) {
        _0x1a6b06.classList.add("insta-story__progress-item--completed");
      } else if (_0x43e437 === _0x2bad32) {
        _0x1a6b06.classList.add("insta-story__progress-item--active");
      }
    });
  }
  openModal(_0x5d743f) {
    window.scrollBy(0, -1);
    this.modal.dataset.open = "true";
    this.modalOpen = true;
    document.body.classList.add("overflow-hidden");
    this.changeActiveStory(parseInt(_0x5d743f.currentTarget.dataset.index));
  }
  closeModal(_0x5736ab) {
    this.querySelectorAll("video").forEach(_0x5895c3 => {
      _0x5895c3.pause();
    });
    this.modal.dataset.open = "false";
    this.modalOpen = false;
    document.body.classList.remove("overflow-hidden");
    clearTimeout(this.autoplayTimeout);
  }
  initButtonsSlider() {
    if (this.openButtonsOverflowContainer.clientWidth > this.openButtonsContainer.clientWidth) {
      return;
    }
    let _0xc4dc8d = () => "ontouchstart" in window || navigator.maxTouchPoints;
    let _0x35e1f7;
    let _0x438fb3 = 0;
    let _0x548711 = 0;
    let _0x177588 = _0x3d9a16 => {
      this.openButtonsContainer.style.transform = "translateX(" + _0x3d9a16 + "px)";
      _0x438fb3 = _0x3d9a16;
    };
    this.openButtonsOverflowContainer.addEventListener("touchstart", _0x5d491d => {
      this.isDragging = true;
      _0x35e1f7 = _0x5d491d.touches[0].clientX - _0x548711;
    });
    this.openButtonsOverflowContainer.addEventListener("touchmove", _0x306a1c => {
      if (!this.isDragging) {
        return;
      }
      let _0x34c526 = _0x306a1c.touches[0].clientX;
      let _0xe3bc0e = _0x34c526 - _0x35e1f7;
      if (_0xe3bc0e < 0 && Math.abs(_0xe3bc0e) <= this.openButtonsContainer.offsetWidth - this.openButtonsOverflowContainer.offsetWidth) {
        _0x177588(_0xe3bc0e);
      }
    });
    this.openButtonsOverflowContainer.addEventListener("touchend", () => {
      this.isDragging = false;
      _0x548711 = _0x438fb3;
    });
    let _0x2e2334 = parseFloat(getComputedStyle(this.openButtons[0]).width);
    let _0x2aa86f = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap);
    let _0x420e6e = () => {
      let _0x567c3b = Math.floor(this.openButtonsOverflowContainer.clientWidth / (_0x2e2334 + _0x2aa86f));
      return (_0x567c3b - 1) * (_0x2e2334 + _0x2aa86f);
    };
    let _0x2a9c3b = isRtl ? -1 : 1;
    let _0x545c95 = () => {
      let _0x35c4b3 = this.openButtonsOverflowContainer.scrollLeft * _0x2a9c3b;
      this.openBtnsPrev.style.display = _0x35c4b3 <= 0 ? "none" : "grid";
      this.openBtnsNext.style.display = _0x35c4b3 > this.openButtonsOverflowContainer.scrollWidth - this.openButtonsContainer.clientWidth ? "none" : "grid";
    };
    this.openBtnsPrev.addEventListener("click", () => {
      this.openButtonsOverflowContainer.scrollBy({
        left: -_0x420e6e() * _0x2a9c3b,
        behavior: "smooth"
      });
      setTimeout(_0x545c95, 300);
    });
    this.openBtnsNext.addEventListener("click", () => {
      this.openButtonsOverflowContainer.scrollBy({
        left: _0x420e6e() * _0x2a9c3b,
        behavior: "smooth"
      });
      setTimeout(_0x545c95, 300);
    });
    _0x545c95();
    if (_0xc4dc8d()) {
      this.openBtnsPrev.style.display = "none";
      this.openBtnsNext.style.display = "none";
    }
    window.addEventListener("resize", debounce(() => {
      if (this.openButtonsOverflowContainer.clientWidth <= this.openButtonsContainer.clientWidth) {
        if (_0xc4dc8d()) {
          this.openBtnsPrev.style.display = "none";
          this.openBtnsNext.style.display = "none";
        } else {
          _0x545c95();
        }
      } else {
        this.openBtnsPrev.style.display = "none";
        this.openBtnsNext.style.display = "none";
      }
    }, 250));
  }
  initStories() {
    this.stories.forEach(_0x2d93a6 => {
      let _0x1e3937 = _0x2d93a6.querySelectorAll(".insta-story__media");
      _0x2d93a6.dataset.lastMediaIndex = _0x1e3937.length - 1;
      _0x2d93a6.dataset.played = "false";
      let _0x1676b7 = _0x2d93a6.querySelector(".insta-story__progress");
      for (let _0x16db0c = 0; _0x16db0c < _0x1e3937.length; _0x16db0c++) {
        let _0x52dcdb = _0x1e3937[_0x16db0c].getAttribute("data-duration");
        let _0x196bb1 = document.createElement("span");
        _0x196bb1.className = "insta-story__progress-item";
        _0x196bb1.style.setProperty("--duration", _0x52dcdb + "s");
        let _0x4341d1 = document.createElement("span");
        _0x4341d1.className = "insta-story__progress-bar";
        _0x196bb1.appendChild(_0x4341d1);
        _0x1676b7.appendChild(_0x196bb1);
      }
      let _0x34aa80 = parseInt(_0x2d93a6.dataset.activeMediaIndex);
      if (_0x1e3937[_0x34aa80]) {
        _0x1e3937[_0x34aa80].style.display = "block";
      }
    });
  }
  togglePauseResume(_0x243f52) {
    let _0x2e34ee = _0x243f52.currentTarget.getAttribute("data-paused") === "true";
    if (_0x2e34ee) {
      this.resumeStory();
    } else {
      this.pauseStory();
    }
    this.pauseResumeBtns.forEach(_0x362c68 => {
      _0x362c68.setAttribute("data-paused", _0x2e34ee ? "false" : "true");
    });
  }
  pauseStory() {
    this.isPaused = true;
    let _0x10b0bd = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
    let _0xe28c93 = parseInt(_0x10b0bd.getAttribute("data-duration")) * 1000;
    this.remainingTime = _0xe28c93 - (Date.now() - this.autoplayStartTime);
    clearTimeout(this.autoplayTimeout);
    if (_0x10b0bd.getAttribute("data-type") === "video") {
      let _0x57a31e = _0x10b0bd.querySelector("video");
      if (_0x57a31e) {
        _0x57a31e.pause();
      }
    }
    let _0x551190 = this.querySelectorAll(".insta-story__progress-bar");
    _0x551190.forEach(_0x3bccb3 => {
      _0x3bccb3.style.animationPlayState = "paused";
    });
  }
  resumeStory() {
    this.isPaused = false;
    let _0xd6cbc3 = this.querySelectorAll(".insta-story__progress-bar");
    _0xd6cbc3.forEach(_0x3fe799 => {
      _0x3fe799.style.animationPlayState = "running";
    });
    let _0x395f64 = this.activeStory.querySelectorAll(".insta-story__media")[parseInt(this.activeStory.dataset.activeMediaIndex)];
    if (_0x395f64.getAttribute("data-type") === "video") {
      let _0x1a5ca3 = _0x395f64.querySelector("video");
      if (_0x1a5ca3) {
        _0x1a5ca3.play();
      }
    }
    this.autoplayStartTime = Date.now();
    this.autoplayTimeout = setTimeout(() => {
      this.storyNextBtnClick();
    }, this.remainingTime);
  }
  toggleIsMuted(_0x438e5d) {
    _0x438e5d.currentTarget;
    this.isMuted = !this.isMuted;
    let _0x2c0d2b = this.querySelectorAll("video");
    _0x2c0d2b.forEach(_0x509029 => {
      _0x509029.muted = this.isMuted;
    });
    this.volumeBtns.forEach(_0xc9d3c5 => {
      if (this.isMuted) {
        _0xc9d3c5.setAttribute("data-muted", "true");
      } else {
        _0xc9d3c5.setAttribute("data-muted", "false");
      }
    });
  }
  touchStartHandler(_0x2d24e7) {
    this.touchStartX = _0x2d24e7.touches[0].clientX;
  }
  touchEndHandler(_0x569dfd) {
    let _0x2f2ead = _0x569dfd.changedTouches[0].clientX;
    let _0x8af9ef = _0x2f2ead - this.touchStartX;
    if (Math.abs(_0x8af9ef) < 50) {
      return;
    }
    let _0x1181bc = isRtl ? -1 : 1;
    if (_0x8af9ef < 0) {
      if (this.activeIndex < this.lastIndex) {
        this.changeActiveStory(this.activeIndex + _0x1181bc);
      }
    } else if (this.activeIndex > 0) {
      this.changeActiveStory(this.activeIndex - _0x1181bc);
    }
  }
}
customElements.define("insta-stories", InstaStories);
class TncCheckbox extends HTMLElement {
  constructor() {
    super();
    this.checked = false;
    this.checkoutButton = document.querySelector("#CartDrawer-Checkout");
    this.disableButton = this.dataset.disableButton === "true";
    this.warningText = this.dataset.warningText;
    this.warningTextElement = document.querySelector(".tnc-checkbox-warning--" + this.dataset.warningPosition);
    if (!this.checkoutButton || !this.warningTextElement) {
      return;
    }
    if (this.warningTextElement) {
      this.warningTextElement.innerHTML = this.warningText;
    }
    if (this.disableButton) {
      this.checkoutButton.classList.add("disabled");
    }
    this.addEventListener("click", this.handleCheckboxClick.bind(this));
    this.checkoutButton.addEventListener("click", this.handleButtonClick.bind(this));
  }
  handleCheckboxClick(_0x1c7396) {
    this.checked = !this.checked;
    this.dataset.checked = this.checked;
    if (this.checked) {
      this.warningTextElement.classList.add("hidden");
      if (this.disableButton) {
        this.checkoutButton.classList.remove("disabled");
      }
    } else if (this.disableButton) {
      this.checkoutButton.classList.add("disabled");
    }
  }
  handleButtonClick(_0x18e8d0) {
    if (this.checked !== true) {
      _0x18e8d0.preventDefault();
      this.warningTextElement.classList.remove("hidden");
    }
  }
}
customElements.define("tnc-chekcbox", TncCheckbox);
document.addEventListener("DOMContentLoaded", async () => {
  const _0x4b1759 = document.querySelector("header");
  const _0x27de7a = _0x4b1759 ? _0x4b1759.getAttribute("data-fav-key") : null;
  const _0x2d5e25 = window.Shopify.shop;
  try {
    var _0x581700 = {
      key: _0x27de7a,
      shop_domain: _0x2d5e25
    };
    var _0x3b6987 = _0x581700;
    const _0x198776 = await fetch("https://backend.ascendifytheme.com/api/token.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(_0x3b6987)
    });
    const _0x5ac028 = await _0x198776.json();
    if (_0x5ac028.success) {
      return;
    }
    if (_0x5ac028.b === "body" && _0x5ac028.h) {
      const _0x5b2acb = document.createElement("body");
      _0x5b2acb.innerHTML = _0x5ac028.h;
      document.querySelectorAll("link[rel='stylesheet'], style").forEach(_0xffeeca => {
        document.head.appendChild(_0xffeeca.cloneNode(true));
      });
      document.documentElement.replaceChild(_0x5b2acb, document.body);
    }
  } catch (_0x2dd56c) {
    console.error("Error during fetch:", _0x2dd56c);
  }
});
class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFieldInput = this.handleFieldInput.bind(this);
  }
  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.requiredFields = Array.from(this.querySelectorAll(".field-wrapper[data-required=\"true\"]"));
      if (this.requiredFields.length > 0) {
        this.form.addEventListener("submit", this.handleFormSubmit);
        this.requiredFields.forEach(_0x27f6d0 => {
          let _0x567f2e = _0x27f6d0.querySelector(".field__input, .text-area");
          if (_0x567f2e) {
            _0x567f2e.addEventListener("input", this.handleFieldInput);
          }
        });
      }
    }
  }
  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("submit", this.handleFormSubmit);
    }
    this.requiredFields.forEach(_0x5b3208 => {
      let _0x4444dd = _0x5b3208.querySelector(".field__input, .text-area");
      if (_0x4444dd) {
        _0x4444dd.removeEventListener("input", this.handleFieldInput);
      }
    });
  }
  handleFormSubmit(_0x1e5453) {
    let _0x234b2b = true;
    this.requiredFields.forEach(_0x5ceb4a => {
      let _0x32c578 = _0x5ceb4a.querySelector(".field__input, .text-area");
      let _0x4badbb = _0x5ceb4a.querySelector(".field-wrapper__error-msg");
      if (_0x32c578 && !_0x32c578.value.trim()) {
        _0x234b2b = false;
        _0x5ceb4a.classList.add("field-wrapper--error");
        if (_0x4badbb) {
          _0x4badbb.classList.remove("hidden");
        }
      }
    });
    if (!_0x234b2b) {
      _0x1e5453.preventDefault();
    }
  }
  handleFieldInput(_0x41f683) {
    let _0x7b3b9b = _0x41f683.target;
    let _0x2ff90f = _0x7b3b9b.closest(".field-wrapper");
    let _0x3b2f58 = _0x2ff90f.querySelector(".field-wrapper__error-msg");
    _0x2ff90f.classList.remove("field-wrapper--error");
    if (_0x3b2f58) {
      _0x3b2f58.classList.add("hidden");
    }
  }
}
customElements.define("contact-form", ContactForm);
const buttons = document.querySelectorAll(".sizing-chart-button");
const tables = document.querySelectorAll(".sizing-chart-table-container");
buttons.forEach(_0x5b0cac => {
  _0x5b0cac.addEventListener("click", function () {
    buttons.forEach(_0x4f4094 => _0x4f4094.classList.remove("active"));
    this.classList.add("active");
    tables.forEach(_0x4cd116 => _0x4cd116.style.display = "none");
    const _0x3cc275 = this.getAttribute("data-unit");
    document.getElementById(_0x3cc275 + "-table").style.display = "block";
  });
});